/* ================= FINAL OPTIMIZED + SAFE JS ================= */

(() => {

  document.addEventListener("DOMContentLoaded", () => {

    /* ===== CART EMPTY CLASS ===== */
    const drawer = document.querySelector('.cart-drawer__dialog');

    function updateCartEmptyClass() {
      if (!drawer) return;
      const items = document.querySelectorAll('.cart-item, .cart-drawer__item');
      drawer.classList.toggle('cart-drawer--empty', items.length === 0);
    }

    updateCartEmptyClass();

    document.addEventListener('click', (e) => {
      if (e.target.closest('[href="/cart"], .cart-icon, .cart-drawer__trigger')) {
        setTimeout(updateCartEmptyClass, 50);
      }
    });

    // 🔥 Listen to Shopify cart update (BEST WAY)
    document.addEventListener('cart:update', updateCartEmptyClass);


    /* ===== SHIPPING + BOGO PRICE ===== */
    function updatePrices(selector, useFormat) {
      const elements = document.querySelectorAll(selector);
      if (!elements.length || !window.Shopify?.currency?.rate) return;

      const rate = parseFloat(Shopify.currency.rate);

      elements.forEach((el) => {
        const rawPrice = parseFloat(el.dataset.price);
        if (isNaN(rawPrice)) return;

        const converted = rawPrice * rate;

        el.textContent = useFormat
          ? Shopify.formatMoney(converted * 100, Shopify.currency.active_format)
          : Shopify.formatMoney(converted * 100);
      });
    }

    updatePrices(".custom-shipping-price", false);
    updatePrices(".bogoprice", true);


    /* ===== ACCORDION ===== */
    document.querySelectorAll(".accordion details").forEach((detail) => {
      detail.addEventListener("toggle", function () {
        if (this.open) {
          document.querySelectorAll(".accordion details").forEach((d) => {
            if (d !== this) d.removeAttribute("open");
          });
        }
      });
    });


    /* ===== SIZE GUIDE MODAL ===== */
    const modal = document.querySelector('.modal-product-size');

    document.querySelector('.size-guide-cta')?.addEventListener('click', () => {
      if (!modal) return;
      modal.style.display = 'flex';
      document.body.classList.add('modal-open');
    });

    document.querySelector('.modal__close')?.addEventListener('click', closeModal);

    window.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    function closeModal() {
      if (!modal) return;
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
    }


    /* ===== FOOTER ACCORDION ===== */
    if (window.innerWidth < 750) {
      document.querySelectorAll(".footer-list-heading").forEach((heading) => {
        heading.addEventListener("click", function () {
          const content = this.nextElementSibling;
          if (!content) return;

          if (content.classList.contains("open")) {
            content.style.height = content.scrollHeight + "px";
            requestAnimationFrame(() => content.style.height = "0px");
            content.classList.remove("open");
          } else {
            content.style.display = "block";
            const fullHeight = content.scrollHeight;

            content.style.height = "0px";
            requestAnimationFrame(() => content.style.height = fullHeight + "px");

            content.classList.add("open");
          }
        });
      });
    }

  });


  /* ===== SHOP THE LOOK CLOSE ===== */
  document.addEventListener('click', (e) => {
    const closeIcon = e.target.closest('.showcase-close-icon');
    if (!closeIcon) return;

    const productBox = closeIcon.closest('.showcase-card-products');
    productBox.classList.remove('open');

    const toggleBtn = productBox.nextElementSibling;
    if (toggleBtn) {
        toggleBtn.style.display = 'block';
    }
  });


  /* ===== VARIANT DROPDOWN ATC ===== */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('.add__select_custom');
    if (!select) return;

    const variantId = select.value;
    if (!variantId) return;

    const form = document.getElementById(select.dataset.formId);
    if (!form) return;

    const productFormComponent = form.closest('product-form-component');
    if (!productFormComponent) return;

    const loader = form.querySelector('.add__custom_loader, .common-loader-atc');

    select.style.display = 'none';
    if (loader) loader.style.display = 'block';

    form.querySelector('[ref="variantId"]').value = variantId;

    function reset() {
      if (loader) loader.style.display = 'none';
      select.style.display = 'block';
      select.value = '';
    }

    // 🔥 Listen real event
    document.addEventListener('cart:update', function handler() {
      document.removeEventListener('cart:update', handler);
      reset();
    });

    // fallback
    setTimeout(reset, 4000);

    if (typeof productFormComponent.handleSubmit === 'function') {
      productFormComponent.handleSubmit(new SubmitEvent('submit', {
        bubbles: true,
        cancelable: true
      }));
    }
  });


  /* ===== ADD TO CART BUTTON ===== */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.add__btn_custom');
    if (!btn) return;

    if (window.location.pathname.includes('/products/')) return;

    const form = document.getElementById(btn.dataset.formId);
    if (!form) return;

    const loader = form.querySelector('.add__custom_loader, .common-loader-atc');

    btn.style.display = 'none';
    if (loader) loader.style.display = 'block';

    function reset() {
      if (loader) loader.style.display = 'none';
      btn.style.display = 'flex';
    }

    // 🔥 real event
    document.addEventListener('cart:update', function handler() {
      document.removeEventListener('cart:update', handler);
      reset();
    });

    // fallback
    setTimeout(reset, 4000);

    const productFormComponent = form.closest('product-form-component');

    if (typeof productFormComponent?.handleSubmit === 'function') {
      productFormComponent.handleSubmit(new SubmitEvent('submit', {
        bubbles: true,
        cancelable: true
      }));
    }
  });

})();

// BRAND FEATURES VIDEO JS START
document.addEventListener('DOMContentLoaded', () => {
  const videoBlocks = document.querySelectorAll('.brand_feature_video');

  videoBlocks.forEach((item) => {
    const media = item.querySelector('video');
    const trigger = item.querySelector('.bf_video_btn');

    trigger.addEventListener('click', () => {
      const isActive = item.classList.contains('playing');

      if (isActive) {
        media.pause();
        item.classList.remove('playing');
      } else {
        // Stop all other videos
        videoBlocks.forEach((block) => {
          const vid = block.querySelector('video');
          if (vid) {
            vid.pause();
            block.classList.remove('playing');
          }
        });

        media.play();
        item.classList.add('playing');
      }
    });
  });
});
// BRAND FEATURES VIDEO JS END


/* :::::::::::::::::::::::::::::: PDP PAGE FOR SHOP THE LOOK PRODUCT ATC BUTTON JS ::::::::::::::::::::::::::::::::::*/
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.pro-collection-gallery.swiper');

  sliders.forEach((slider) => {
    const paginationEl = document.createElement('div');
    paginationEl.classList.add('swiper-pagination');
    slider.appendChild(paginationEl);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 600,
      loop: false,
      preloadImages: false,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 1
        }
      }
    });
  });
});

/*--------------------------------------------------------------------------------
                    START :: MPS_091_product PDP SHOP THE LOOK
--------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // Capped: this section only exists on the PDP, so elsewhere it would poll forever.
  var lookAttempts = 0;

  var lookIdset = setInterval(() => {
    if (++lookAttempts > 40) {
      clearInterval(lookIdset);
      return;
    }

    var section = document.querySelector('.mps-lookbook-products--section');
    if (!section) return;

    var grid = section.querySelector('.productlook-grid');
    if (!grid) return;

    var objLookup = grid.querySelectorAll('.productlook.grid__item');

    if (objLookup.length > 0) {
      objLookup.forEach((item) => {
        var getPid = item.getAttribute('data-product-id');
        lookupGalleryChange(getPid);
      });
      clearInterval(lookIdset);
    }
  }, 500);
});

document.addEventListener('change', (e) => {
  var colorTarget = e.target.closest('.mps-lookbook-products--section [name="Color"]');
  if (colorTarget) {
    var pid = colorTarget.getAttribute('data-pid');
    var vid = colorTarget.getAttribute('data-vid');
    var productCheck = colorTarget.closest('.productlook');

    if (productCheck) {
      productCheck.querySelectorAll('label').forEach((label) => {
        label.classList.remove('active');
      });
    }

    lookupGalleryChange(pid, vid);
    return;
  }

  var versionTarget = e.target.closest('.mps-lookbook-products--section [name="Version"]');
  if (versionTarget) {
    var wrap = versionTarget.closest('.productlook');
    if (!wrap) return;

    var checkedColor = wrap.querySelector('[name="Color"]:checked');
    if (checkedColor) {
      checkedColor.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

function stringToHandle(str) {
  if (!str) return '';
  return String(str)
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function lookupGalleryChange(pid, vid) {
  var mainProductObj = null;

  var grid = document.querySelector('.productlook-grid');
  if (grid) {
    var match = grid.querySelector('.productlook[data-product-id="' + pid + '"]');
    if (match) {
      mainProductObj = match;
    }
  }

  document.querySelectorAll('.flickity-enabled').forEach((flickity) => {
    var dots = flickity.querySelector('.flickity-page-dots');
    if (dots) {
      dots.style.display = 'none';
    }
  });

  var activeStyles = {
    opacity: '1',
    visibility: 'visible',
    pointerEvents: 'auto',
    position: 'unset'
  };

  var hiddenStyles = {
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    position: 'absolute'
  };

  function applyStyles(el, styles) {
    if (!el) return;
    Object.assign(el.style, styles);
  }

  var flagVersion = 0;

  if (mainProductObj) {
    var versionInputs = mainProductObj.querySelectorAll('[name="Version"]');

    if (versionInputs.length > 0) {
      var checkedVersion = mainProductObj.querySelector('[name="Version"]:checked');
      var getVersion = checkedVersion ? checkedVersion.value : '';
      var getColorImg = '';

      var colorInputs = mainProductObj.querySelectorAll('[name="Color"]');
      if (colorInputs.length > 0) {
        var checkedColor = mainProductObj.querySelector('input[type="radio"][name="Color"]:checked');
        if (checkedColor) {
          getColorImg = checkedColor.getAttribute('limited-edition-img');
        }
      }

      getVersion = stringToHandle(getVersion);

      if (getVersion === 'limited-edition' && getColorImg !== undefined && getColorImg !== null) {
        var limitedSlider = mainProductObj.querySelector('.limited-gallery-slider.pro-collection-gallery-' + pid);
        var mainSlider = mainProductObj.querySelector('.main-collection-slider.pro-collection-gallery-' + pid);

        if (limitedSlider) {
          limitedSlider.style.display = '';
          applyStyles(limitedSlider, activeStyles);
        }

        if (mainSlider) {
          applyStyles(mainSlider, hiddenStyles);
        }

        if (limitedSlider) {
          var limitedTarget = limitedSlider.querySelector('.grid-product__link [data-main-image="' + getColorImg + '"]');

          if (limitedTarget) {
            var limitedSlide = limitedTarget.closest('.swiper-slide');
            if (limitedSlide) {
              var limitedIndex = Array.from(limitedSlide.parentNode.children).indexOf(limitedSlide);

              if (limitedSlider.swiper && limitedIndex >= 0) {
                limitedSlider.swiper.slideTo(limitedIndex);
              }
            }
          }
        }
      } else if (getVersion !== undefined && getVersion !== '') {
        flagVersion = 1;
      }
    } else {
      flagVersion = 1;
    }

    if (flagVersion === 1) {
      var colorFields = mainProductObj.querySelectorAll('[name="Color"]');

      if (colorFields.length > 0) {
        var limitedSliderFlag = mainProductObj.querySelector('.limited-gallery-slider.pro-collection-gallery-' + pid);
        var mainSliderFlag = mainProductObj.querySelector('.main-collection-slider.pro-collection-gallery-' + pid);

        if (mainSliderFlag) {
          if (limitedSliderFlag) {
            limitedSliderFlag.style.display = 'none';
            applyStyles(limitedSliderFlag, hiddenStyles);
          }

          applyStyles(mainSliderFlag, activeStyles);

          var parentGallery = mainSliderFlag.closest('.pgi-rsquare.pgi-gallery');
          if (parentGallery) {
            parentGallery.style.display = '';
          }
        }

        if (vid && mainSliderFlag) {
          var mainTarget = mainSliderFlag.querySelector('.grid-product__link.image-variant-' + vid);

          if (mainTarget) {
            var mainSlide = mainTarget.closest('.swiper-slide');
            if (mainSlide) {
              var mainIndex = Array.from(mainSlide.parentNode.children).indexOf(mainSlide);

              if (mainSliderFlag.swiper && mainIndex >= 0) {
                mainSliderFlag.swiper.slideTo(mainIndex);
              }
            }
          }
        }
      }
    }
  }
}

/* MOBILE PRODUCT CARD VARIANT JS START */
document.addEventListener('change', (e) => {
  const target = e.target.closest('.mps-lookbook-plist .product-card_variant .variant-select');
  if (!target) return;

  const selectedObj = target.closest('.product-card_variant');
  getVariantSelected(selectedObj);
});

function getVariantSelected(selectedObj) {
  const variantSelects = selectedObj.querySelectorAll('.variant-select');
  if (!variantSelects.length) return;

  let variantStr = '';

  variantSelects.forEach((select) => {
    if (variantStr !== '') {
      variantStr += '-';
    }

    const selectedOption = select.querySelector('option:checked');
    const secondOption = select.querySelectorAll('option')[1];

    if (selectedOption && selectedOption.getAttribute('data-handle')) {
      variantStr += selectedOption.getAttribute('data-handle');
    } else if (secondOption && secondOption.getAttribute('data-handle')) {
      variantStr += secondOption.getAttribute('data-handle');
    }
  });

  if (variantStr) {
    const productCard = selectedObj.closest('.product-card');
    const variantSelect = productCard ? productCard.querySelector('.product-single__variants') : null;

    if (!variantSelect) return;

    const matchedOption = variantSelect.querySelector('option[data-handle="' + variantStr + '"]');

    if (matchedOption && matchedOption.value) {
      variantSelect.value = matchedOption.value;
      variantSelect.dispatchEvent(new Event('change'));
    }
  }
}

/* MOBILE PRODUCT CARD VARIANT JS END */

/*--------------------------------------------------------------------------------
                    END :: MPS_091_product PDP SHOP THE LOOK
--------------------------------------------------------------------------------*/


document.addEventListener('change', (e) => {
  const parent = e.target.closest('.productlook');
  if (!parent) return;

  const variantInput = e.target.closest('[data-variant-input]');
  if (!variantInput) return;

  const form = parent.querySelector('form');
  if (!form) return;
  const result = getFormSelections(parent);
  if(result.variantId!=null){
    parent.querySelector('.variant-id-input').value = result.variantId;
  }
});

function getFormSelections(form) {
  const data = {};

  // 2. Checked radio buttons - data-value collect karo
  const checkedRadios = form.querySelectorAll('input[type="radio"]:checked');
  data.checkedRadios = Array.from(checkedRadios).map((radio) => radio.dataset.value);

  // 3. Selected options from select[data-variant-input]
  const selectInputs = form.querySelectorAll('select[data-variant-input]');
  data.selectedOptions = Array.from(selectInputs).map((select) => {
    const selectedOption = select.options[select.selectedIndex];
    return selectedOption ? selectedOption.dataset.value : null;
  });

  // 4. Merge all data-value into one flat handle array
  data.handle = [
    ...data.checkedRadios,
    ...data.selectedOptions
  ].filter(Boolean).join(' / ');
  // 5. Get variant ID from [data-product-select]
  const productSelect = form.querySelector('select[data-product-select]');
  if (productSelect) {
    const matchedVariant = getVariantByHandle(productSelect, data.handle);
    data.variantId = matchedVariant ? matchedVariant.value : null;
  } else {
    data.variantId = null;
  }
  //console.log('data', data.variantId);
  return data;
}

function getVariantByHandle(productSelect, handle) {
  const options = Array.from(productSelect.options);

  // Exact match first
  const exact = options.find((opt) => opt.dataset.handle === handle);
  if (exact) return exact;

  // Fallback: match by joining handle parts (case-insensitive)
  const normalizedHandle = handle.toLowerCase().replace(/\s\/\s/g, '-');
  return options.find((opt) => opt.dataset.handle === normalizedHandle) || null;
}

function resetLookupCheckbox() {
  document.querySelectorAll('.productlook-grid .atc_checkbox:checked').forEach((checkbox) => {
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event('change'));
  });
}

function loaderHideLookup(button) {
  if (button) {
    button.classList.remove('btn--loading');
    button.disabled = false;
  } else {
    document.querySelectorAll('.productlook-grid .talb-plist_btn').forEach((btn) => {
      btn.classList.remove('btn--loading');
      btn.disabled = false;
    });
  }
}

function updateHorizonCartDrawer(sectionsHtml) {
  if (!sectionsHtml || !sectionsHtml['header-section']) return false;

  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionsHtml['header-section'], 'text/html');

  const newDrawer = doc.querySelector('cart-drawer-component');
  const currentDrawer = document.querySelector('cart-drawer-component');

  if (newDrawer && currentDrawer) {
    currentDrawer.innerHTML = newDrawer.innerHTML;
  }

  const newBubble = doc.querySelector('[data-testid="cart-drawer-trigger"]');
  const currentBubble = document.querySelector('[data-testid="cart-drawer-trigger"]');

  if (newBubble && currentBubble) {
    currentBubble.replaceWith(newBubble.cloneNode(true));
  }

  return true;
}

function openHorizonCartDrawer() {
  const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

  if (trigger) {
    trigger.click();
    return true;
  }

  const drawer = document.querySelector('cart-drawer-component');

  if (drawer) {
    drawer.setAttribute('open', 'open');
    drawer.classList.add('is-open', 'active');
    return true;
  }

  return false;
}


/* :::::::::::::::::::::::::::::: PDP PAGE FOR SHOP THE LOOK PRODUCT ATC BUTTON JS ::::::::::::::::::::::::::::::::::*/

/* ---------------------------------------------------------------------------------
      CART - offer-popup toggle
--------------------------------------------------------------------------------- */

document.addEventListener('click', (e) => {
  if (e.target.closest('.offer-box-wrapper .offer-button .info-icon')) {
    var offerPopup = document.querySelector('.offer-box-wrapper .offer-popup');

    if (offerPopup) {
      var isHidden = window.getComputedStyle(offerPopup).display === 'none';
      offerPopup.style.display = isHidden ? 'block' : 'none';
    }
    return;
  }

  if (e.target.closest('.offer-box-wrapper .offer-popup .close-toggle-btn')) {
    var offerPopup = document.querySelector('.offer-box-wrapper .offer-popup');
    if (offerPopup) {
      offerPopup.style.display = 'none';
    }
  }
});

/* ---------------------------------------------------------------------------------
      CART - offer-popup toggle
--------------------------------------------------------------------------------- */

// ── Cart Upsell: Common ATC for v5, v6, v8 ───────────────────────────
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.cup_atc_btn');
  if (!btn) return;
  if (!btn.closest('.cart_upsell_variant')) return;
  const card = btn.closest('.cart_upsell_card');

  //console.log("catrdd",card);
  if (!card) return;

  const select    = card.querySelector('.select_variants');
  const variantId = select ? select.value : card.getAttribute('data-pid');
  if (!variantId) return;

  const icon   = btn.querySelector('span');
  const loader = btn.querySelector('.custom--loader');
  icon.style.display   = 'none';
  loader.style.display = 'block';
  btn.disabled         = true;

  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
  })
  .then((r) => r.json())
  .then((data) => {
      icon.style.display   = '';
      loader.style.display = 'none';
      btn.disabled         = false;

      if (data.status) { console.error('[CTL ATC]', data.description); return; }

      fetch('/cart.js?sections=cart-drawer')
        .then((r) => r.json())
        .then((cart) => {
            document.querySelectorAll(
                'cart-count, [data-cart-count], .cart-count, .js-cart-count, #cart-count'
            ).forEach((el) => { el.textContent = cart.item_count; });

            document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                    resource: cart,
                    sourceId: null,
                    data: { itemCount: cart.item_count, sections: cart.sections },
                },
            }));

            var cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            }
        });
      })
    .catch((err) => {
        icon.style.display   = '';
        loader.style.display = 'none';
        btn.disabled         = false;
        console.error('[CTL ATC] Error:', err);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // ── Swiper instances (let so reinitSwipers can reassign) ──────────────
    let swiperInstances = {};
    let swiperVtwo      = null;
    let swiperVfive     = null;
    let lastActiveVsixTab = null;
    let isReinitInProgress = false;

    // ── Safe Swiper helpers ───────────────────────────────────────────────
    function initSwiper(elOrSelector, options) {
        const el = typeof elOrSelector === 'string'
            ? document.querySelector(elOrSelector)
            : elOrSelector;
        if (!el) return null;
        try {
            return new Swiper(el, options);
        } catch (err) {
            console.warn('[Swiper] Init failed on', el, err);
            return null;
        }
    }

    function safeUpdate(swiper) {
        if (!swiper) return;
        try {
            if (swiper.el && document.contains(swiper.el) && typeof swiper.update === 'function') {
                swiper.update();
            }
        } catch (err) {
            console.warn('[Swiper] Update failed:', err);
        }
    }

    function safeDestroy(swiper) {
        if (!swiper) return;
        try { swiper.destroy(true, true); } catch (_) {}
    }

    // FIX: wait until the upsell container actually has layout (non-zero width)
    function whenContainerVisible(cb, attempts) {
        attempts = attempts || 0;
        const container = document.querySelector('.ctl-upsell') || document.body;
        if (container.offsetWidth > 0 || attempts >= 15) {
            cb();
            return;
        }
        requestAnimationFrame(() => {
            whenContainerVisible(cb, attempts + 1);
        });
    }

    // ───────────────────────────────────────────────────────────────────
    // FIX: navigation (prev/next arrow) state ne force-correct karva nu.
    // ───────────────────────────────────────────────────────────────────
    function forceRefreshNavigation(swiper) {
      if (!swiper || !swiper.el || !document.contains(swiper.el)) return;
      if (swiper.__navRefreshing) return;
      swiper.__navRefreshing = true;

      try {
          const allSlides = swiper.slides ? Array.from(swiper.slides) : [];

          const visibleIndexes = allSlides.reduce((arr, slide, index) => {
              if (!slide.classList.contains('upsell-hidden')) {
                  arr.push(index);
              }
              return arr;
          }, []);

          if (visibleIndexes.length > 0) {
              const currentIdx = swiper.activeIndex;

              const currentSlideHidden =
                  allSlides[currentIdx] &&
                  allSlides[currentIdx].classList.contains('upsell-hidden');

              if (currentSlideHidden) {
                  const targetIndex = visibleIndexes[0];
                  swiper.slideTo(targetIndex, 0, false);
              }
          }

          swiper.updateSize();
          swiper.updateSlides();
          swiper.updateSlidesOffset();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          swiper.update();

          requestAnimationFrame(() => {
            if (swiper.navigation) {
              const navLooksBroken =
                  !swiper.navigation.prevEl && !swiper.navigation.nextEl;

              if (navLooksBroken &&
                  typeof swiper.navigation.destroy === 'function' &&
                  typeof swiper.navigation.init === 'function') {
                  swiper.navigation.destroy();
                  swiper.navigation.init();
              }

              if (typeof swiper.navigation.update === 'function') {
                  swiper.navigation.update();
              }
            }

            swiper.updateProgress();
            swiper.updateSlidesClasses();
            swiper.__navRefreshing = false;
          });

      } catch (err) {
          console.warn('[Swiper] navigation refresh failed:', err);
          swiper.__navRefreshing = false;
      }
    }

    // ── Swiper lifecycle ──────────────────────────────────────────────────
    function initSwipers() {
      swiperVtwo = initSwiper('.cart_upsell_swiper_vtwo', {
          slidesPerView: 2.5,
          spaceBetween: 10,
      });

      swiperVfive = initSwiper('.cart_upsell_swiper_vfive', {
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        on: {
          observerUpdate: (sw) => {
            refreshVfiveArrowState(sw);
          },
          slideChange: (sw) => {
            refreshVfiveArrowState(sw);
          },
        },
      });
      window.__debugSwiperVfive = swiperVfive;

      if (swiperVfive) {
        requestAnimationFrame(() => {
          swiperVfive.el.offsetHeight;
          swiperVfive.updateSize();
          swiperVfive.updateSlides();
          swiperVfive.updateSlidesOffset();
          swiperVfive.updateProgress();
          swiperVfive.updateSlidesClasses();
          swiperVfive.update();

          swiperVfive.slideTo(0, 0, false);

          swiperVfive.update();

          refreshVfiveArrowState(swiperVfive);
        });
      }

      document.querySelectorAll('.tab-content').forEach((panel) => {
        const panelId        = panel.getAttribute('data-panel');
        const swiperEl       = panel.querySelector('.cart_upsell_swiper_vsix');
        if (!swiperEl || !panelId) return;
        const scrollbarEl    = panel.querySelector('.swiper-scrollbar');
        const progressbarEl  = panel.querySelector('.swiper-progressbar');

        const instance = initSwiper(swiperEl, {
            slidesPerView: 2.4,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            scrollbar: {
                el: scrollbarEl,
                draggable: true
            },
            pagination: {
                el: progressbarEl,
                type: 'progressbar',
            },
        });
        if (instance) swiperInstances[panelId] = instance;
      });
    }

    function destroyAllSwipers() {
        safeDestroy(swiperVtwo);
        safeDestroy(swiperVfive);
        Object.values(swiperInstances).forEach(safeDestroy);
        swiperVtwo      = null;
        swiperVfive     = null;
        swiperInstances = {};
    }

    function reinitSwipers(callback) {

      if (isReinitInProgress) return;
      isReinitInProgress = true;

      destroyAllSwipers();

      document.querySelectorAll('[data-upsell-active="true"]').forEach((el) => {
          el.removeAttribute('data-upsell-active');
      });

      whenContainerVisible(() => {
        initSwipers();

        isReinitInProgress = false;

        if (typeof callback === "function") {
            callback();
        }
      });
    }

    // ── Initial swiper setup ────────────────────────────────────────────
    whenContainerVisible(initSwipers);

    // ── Tabs ──────────────────────────────────────────────────────────────
    document.addEventListener('click', (e) => {

      const tab = e.target.closest('ul.cart_upsell_tabs li');

      if (!tab) return;

      const tab_id = tab.getAttribute('data-tab');

      lastActiveVsixTab = tab_id;

      document.querySelectorAll('ul.cart_upsell_tabs li').forEach((t) => {
          t.classList.remove('current');
      });

      tab.classList.add('current');

      document.querySelectorAll('.tab-content').forEach((c) => {
          c.classList.remove('current');
      });

      const activePanel = document.querySelector(
          '.tab-content[data-panel="' + tab_id + '"]'
      );

      if (activePanel) {
          activePanel.classList.add('current');
      }

      if (swiperInstances[tab_id]) {
          safeUpdate(swiperInstances[tab_id]);
      }
    });

    // FIX: delegated arrow clicks for vfive. Attached to document (not to the
    // buttons themselves) so it survives Shopify replacing the button nodes.
    document.addEventListener('click', (e) => {
      const prevBtn = e.target.closest('.cart_upsell_vfive .cu_slider_arrow_prev');
      const nextBtn = e.target.closest('.cart_upsell_vfive .cu_slider_arrow_next');

      if (!prevBtn && !nextBtn) return;
      if (!swiperVfive || !swiperVfive.el || !document.contains(swiperVfive.el)) return;

      swiperVfive.update();

      const visibleIndexes = Array.from(swiperVfive.slides)
          .map((slide, index) => slide.classList.contains('upsell-hidden') ? null : index)
          .filter(index => index !== null);

      if (!visibleIndexes.length) return;

      const currentIdx = swiperVfive.activeIndex;
      let target = null;

      if (nextBtn) {
          target = visibleIndexes.find(i => i > currentIdx);
      } else {
          target = [...visibleIndexes].reverse().find(i => i < currentIdx);
      }

      if (target !== undefined && target !== null) {

          swiperVfive.slideTo(target, 300);

          // Animation complete thay pachi arrows update karo
          swiperVfive.once('transitionEnd', () => {
              refreshVfiveArrowState(swiperVfive);
          });

      }
    });

    // FIX: keeps the arrow disabled/enabled look in sync with the ACTUAL
    // visible slides (not Swiper's own isBeginning/isEnd, which only knows
    // about total slide count, not which ones are upsell-hidden).
    function refreshVfiveArrowState(sw) {
      const container = sw.el.closest('.cart_upsell_vfive');
      if (!container) return;

      const prevArrow = container.querySelector('.cu_slider_arrow_prev');
      const nextArrow = container.querySelector('.cu_slider_arrow_next');

      const visibleSlides = Array.from(sw.slides).filter(
          slide => !slide.classList.contains('upsell-hidden')
      );

      // Current visible slide shodho
      const currentVisibleSlide = visibleSlides.find(
          slide => slide.classList.contains('swiper-slide-active')
      );

      const currentVisibleIndex = visibleSlides.indexOf(currentVisibleSlide);

      prevArrow.classList.toggle(
          'swiper-button-disabled',
          currentVisibleIndex <= 0
      );

      nextArrow.classList.toggle(
          'swiper-button-disabled',
          currentVisibleIndex >= visibleSlides.length - 1
      );
    }

    // ── MutationObserver: re-run visibility after section re-renders ──────
    (function setupReRenderWatcher() {
      var watchTarget = document.querySelector('cart-drawer-component')
                  || document.querySelector('.cart-drawer')
                  || document.body;
      var pending = false;

      new MutationObserver((mutations) => {
        if (pending) return;
        var upsellAdded = mutations.some((m) => Array.from(m.addedNodes).some((n) => {
                if (n.nodeType !== 1) return false;
                return n.id === 'complete-the-look'
                    || n.classList.contains('ctl-upsell')
                    || (n.querySelector && n.querySelector('.ctl-upsell'));
            }));

        if (!upsellAdded) return;

        pending = true;
        setTimeout(() => {
          pending = false;
          reinitSwipers(() => {
              updateUpsellVisibility();
          });
        }, 300);
      }).observe(watchTarget, { childList: true, subtree: true });
  })();


    // ── Debounced handler for cart changes WITHOUT a section re-render ────
    var cartChangeTimer = null;
    function handleCartChange() {
        clearTimeout(cartChangeTimer);
        cartChangeTimer = setTimeout(() => {
            if (isReinitInProgress) return;
            var detached = (swiperVfive && !document.contains(swiperVfive.el)) ||
                           Object.values(swiperInstances).some((s) => s && !document.contains(s.el));
            if (detached) reinitSwipers();
            updateUpsellVisibility();
        }, 1000);
    }

    ['cart:update', 'cart:refresh', 'cart:change'].forEach((evt) => {
      document.addEventListener(evt, handleCartChange);
    });

    // =========================
    // UPSELL CODE START
    // =========================

    async function getCartProductIds() {
        try {
            const res  = await fetch('/cart.js');
            const cart = await res.json();
            return cart.items.map((item) => String(item.product_id));
        } catch (e) {
            return [];
        }
    }

    function blockIsVisible(block) {
        try {
            const savedValue    = block.style.getPropertyValue('display');
            const savedPriority = block.style.getPropertyPriority('display');
            block.style.removeProperty('display');
            const visible = window.getComputedStyle(block).display !== 'none';
            if (savedValue) block.style.setProperty('display', savedValue, savedPriority);
            return visible;
        } catch (_) {
            return block.offsetParent !== null;
        }
    }

    // ── manual translate calculation — bypasses Swiper's slidesGrid ───────
    function forceVfiveTranslate(swiper) {
      if (!swiper || !swiper.el) return;

      const firstVisibleIdx = Array.from(swiper.slides).findIndex(
          slide => !slide.classList.contains('upsell-hidden')
      );

      if (firstVisibleIdx >= 0 && swiper.activeIndex !== firstVisibleIdx) {
          swiper.slideTo(firstVisibleIdx, 0, false);
          swiper.update();
      }
    }

    // ── Show / hide vfive navigation arrows ──────────────────────────────
    function updateVfiveArrows(activeBlock, visibleCount) {
        if (!activeBlock || !activeBlock.classList.contains('cart_upsell_vfive')) return;

        var prevArrow = activeBlock.querySelector('.cu_slider_arrow_prev');
        var nextArrow = activeBlock.querySelector('.cu_slider_arrow_next');
        if (!prevArrow || !nextArrow) return;
        if (visibleCount <= 1) {
            prevArrow.style.setProperty('display', 'none', 'important');
            nextArrow.style.setProperty('display', 'none', 'important');
        } else {
            prevArrow.style.removeProperty('display');
            nextArrow.style.removeProperty('display');
            refreshVfiveArrowState(swiperVfive);
        }
    }

    async function updateUpsellVisibility() {
        const cartProductIds = await getCartProductIds();
        let visibleCount = 0;

        const variantClasses = ['cart_upsell_vfive', 'cart_upsell_vsix', 'cart_upsell_veight'];
        const mainBlock      = document.querySelector('.ctl-upsell');

        let activeBlock = null;
        if (mainBlock) {
            const markedBlock = mainBlock.querySelector('[data-upsell-active="true"]');
            if (markedBlock) {
                activeBlock = markedBlock;
            } else {
                variantClasses.forEach((cls) => {
                    if (activeBlock) return;
                    const block = mainBlock.querySelector('.' + cls);
                    if (!block) return;
                    if (blockIsVisible(block)) {
                        activeBlock = block;
                        block.setAttribute('data-upsell-active', 'true');
                    }
                });
            }
        }

        if (!activeBlock) { updateAllSwipers(); return; }

        const isVsix = activeBlock.classList.contains('cart_upsell_vsix');

        if (isVsix) {
            const allTabs = activeBlock.querySelectorAll('.tab-content');
            let atLeastOneTabVisible = false;

            allTabs.forEach((tabContent) => {
                let tabVisibleCount = 0;
                tabContent.querySelectorAll('.cart_upsell_card[data-pid]').forEach((card) => {
                    const pid    = String(card.getAttribute('data-pid'));
                    const slide  = card.closest('.cart_upsell_slide, .swiper-slide');
                    const target = slide || card;
                    if (cartProductIds.includes(pid)) {
                        target.classList.add('upsell-hidden');
                    } else {
                        target.classList.remove('upsell-hidden');
                        tabVisibleCount++;
                    }
                });
                if (tabVisibleCount > 0) {
                    atLeastOneTabVisible = true;
                    visibleCount += tabVisibleCount;
                }
                tabContent.setAttribute('data-visible-count', String(tabVisibleCount));
            });

            allTabs.forEach((tabContent) => {
                const panelId = tabContent.getAttribute('data-panel');
                const tabLink = activeBlock.querySelector('.tab-link[data-tab="' + panelId + '"]');
                const count   = parseInt(tabContent.getAttribute('data-visible-count'), 10);
                if (!tabLink) return;
                if (count === 0) {
                    tabLink.style.setProperty('display', 'none', 'important');
                } else {
                    tabLink.style.removeProperty('display');
                }
            });

            if (lastActiveVsixTab) {
              const savedTab =
                  activeBlock.querySelector(
                      '.tab-content[data-panel="' + lastActiveVsixTab + '"]'
                  );

              const savedLink =
                  activeBlock.querySelector(
                      '.tab-link[data-tab="' + lastActiveVsixTab + '"]'
                  );

               const currentTab = activeBlock.querySelector('.tab-content.current');
                const currentCount = currentTab
                  ? parseInt(currentTab.getAttribute('data-visible-count'), 10) || 0
                  : 0;

                if (
                    savedTab &&
                    savedLink &&
                    !savedTab.classList.contains('current') &&
                    parseInt(savedTab.getAttribute('data-visible-count'), 10) > 0
                ){

                  allTabs.forEach((t) => {
                      t.classList.remove('current');
                  });

                  activeBlock.querySelectorAll('.tab-link').forEach((l) => {
                      l.classList.remove('current');
                  });

                  savedTab.classList.add('current');

                  if (savedLink) {
                      savedLink.classList.add('current');
                  }
              }
            }

            const currentTab = activeBlock.querySelector('.tab-content.current');
            if (currentTab) {

                const currentPanel = activeBlock.querySelector('.tab-content.current');

                const currentCount = currentPanel
                    ? parseInt(currentPanel.getAttribute('data-visible-count'), 10) || 0
                    : 0;

                if (currentCount === 0) {
                  currentTab.classList.remove('current');
                  const currentPanelId =
                      currentTab.getAttribute('data-panel');

                  const currentLink =
                      activeBlock.querySelector(
                          '.tab-link[data-tab="' + currentPanelId + '"]'
                      );

                  if (currentLink) {
                    currentLink.classList.remove('current');
                  }

                  let nextVisiblePanel = null;

                  allTabs.forEach((panel) => {

                      const count = parseInt(
                          panel.getAttribute('data-visible-count'),
                          10
                      ) || 0;

                      if (
                          count > 0 &&
                          panel.getAttribute('data-panel') !== currentPanelId &&
                          !nextVisiblePanel
                      ) {
                          nextVisiblePanel = panel;
                      }
                  });
                  let retryCount = 0;

                  const upsellId = setInterval(() => {

                      retryCount++;

                      if (nextVisiblePanel) {

                          activeBlock.querySelectorAll('.tab-content').forEach((panel)=> {
                              panel.classList.remove('current');
                          });

                          activeBlock.querySelectorAll('.tab-link').forEach((link)=> {
                              link.classList.remove('current');
                          });

                          nextVisiblePanel.classList.add('current');

                          const link = activeBlock.querySelector(
                              '.tab-link[data-tab="' +
                              nextVisiblePanel.getAttribute('data-panel') +
                              '"]'
                          );

                          if (link) {
                              link.classList.add('current');
                          }

                          lastActiveVsixTab =
                              nextVisiblePanel.getAttribute('data-panel');

                          if (swiperInstances[lastActiveVsixTab]) {
                              safeUpdate(swiperInstances[lastActiveVsixTab]);
                          }
                      }


                      if (retryCount >= 3) {
                          clearInterval(upsellId);
                      }

                  }, 300);
                }else{
                  lastActiveVsixTab = currentTab.getAttribute('data-panel');
                  const swiperInst = swiperInstances[lastActiveVsixTab];

                  if (swiperInst) {
                    let retryCount = 0;

                    const slideResetId = setInterval(() => {
                      retryCount++;

                      if (swiperInst && swiperInst.el && document.contains(swiperInst.el)) {
                        swiperInst.update();
                        swiperInst.slideTo(0, 0, false);
                      }

                      if (retryCount >= 3) {
                        clearInterval(slideResetId);
                      }
                    }, 300);
                  }
                }
            }
            if (atLeastOneTabVisible) {
                activeBlock.style.setProperty('display', 'block', 'important');
                mainBlock.style.setProperty('display', 'block', 'important');
            } else {
                activeBlock.style.setProperty('display', 'none', 'important');
                mainBlock.style.setProperty('display', 'none', 'important');
            }
        } else {
          // ── vfive / veight ────────────────────────────────────────────
          activeBlock.querySelectorAll('.cart_upsell_card[data-pid]').forEach((card) => {
            const pid    = String(card.getAttribute('data-pid'));
            const slide  = card.closest('.cart_upsell_slide, .swiper-slide');
            const target = slide || card;
            if (cartProductIds.includes(pid)) {
              target.classList.add('upsell-hidden');
            } else {
              target.classList.remove('upsell-hidden');
              visibleCount++;
            }
          });
          setTimeout(() => {
            updateVfiveArrows(activeBlock, visibleCount);
            const completeLook = document.getElementById('complete-the-look');
            if (visibleCount === 0) {
              if (completeLook) completeLook.classList.add('upsell-hidden');
              mainBlock.style.setProperty('display', 'none', 'important');
            } else {
              if (completeLook) completeLook.classList.remove('upsell-hidden');
              mainBlock.style.setProperty('display', 'block', 'important');
            }
          }, 500);
        }
        updateAllSwipers();
    }

    // =========================
    // SWIPER UPDATE HELPER
    // =========================
    function updateAllSwipers() {
      [swiperVtwo, swiperVfive, ...Object.values(swiperInstances)]
        .filter(Boolean)
        .forEach((swiper) => {
          if (!swiper.el || !document.contains(swiper.el)) return;

          try {
            swiper.update();
            if (
                swiper.scrollbar &&
                typeof swiper.scrollbar.init === 'function'
            ) {
              swiper.scrollbar.init();
              swiper.scrollbar.updateSize();
            }
            requestAnimationFrame(() => {
              if (swiper === swiperVfive) {
                  // vfive: manual translate, only touches position when the
                  // active slide actually needs to move (see fix above)
                  forceVfiveTranslate(swiper);
                  refreshVfiveArrowState(swiper);
                  return;
              }

              const visibleSlides = Array.from(swiper.slides || [])
                  .filter(slide => !slide.classList.contains('upsell-hidden'));

              if (visibleSlides.length === 0) {
                  return;
              }

              const activeSlide = swiper.slides[swiper.activeIndex];
              if (
                  activeSlide &&
                  activeSlide.classList.contains('upsell-hidden')
              ) {
                  const firstVisibleIndex = Array.from(swiper.slides)
                      .findIndex(slide =>
                          !slide.classList.contains('upsell-hidden')
                      );
                  if (firstVisibleIndex >= 0) {
                      swiper.slideTo(firstVisibleIndex, 0, false);
                  }
              }

              forceRefreshNavigation(swiper);
            });
          } catch (err) {
              console.warn('[Swiper] update failed:', err);
          }
        });
    }

    updateUpsellVisibility();
    // =========================
    // UPSELL CODE END
    // =========================
});
// ── Cart Upsell: Common ATC for v5, v6, v8 END ───────────────────────────

/**************************  PRODUCT BUNDLE SELECTOR -- START  ************************/

// ─────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────
function handleize(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

function bundleActiveVersion() {
  return (
    document.body.classList.contains('bundle_selector_vone') ||
    document.body.classList.contains('bundle_selector_vtwo') ||
    document.body.classList.contains('bundle_selector_vthree')
  );
}

function getDiscountPercent(comparePrice, salePrice) {
  if (!comparePrice || !salePrice || comparePrice <= salePrice) return 0;
  var percentOff = ((comparePrice - salePrice) / comparePrice) * 100;
  return Math.round(percentOff);
}

function qs(selector, context) {
  return (context || document).querySelector(selector);
}

function qsa(selector, context) {
  return Array.from((context || document).querySelectorAll(selector));
}

// ─────────────────────────────────────────────
// Gallery scroll — shared timer + session ID
// ─────────────────────────────────────────────

var _sharedGalleryScrollTimer = null;
var _scrollSessionId = 0;

function scheduleColorSlideScroll(delay) {
  clearTimeout(_sharedGalleryScrollTimer);
  var mySession = ++_scrollSessionId;

  _sharedGalleryScrollTimer = setTimeout(() => {
    if (mySession !== _scrollSessionId) return; // superseded by newer call

    var version = getCurrentVersion();
    var gallery = getGalleryByVersion(version);
    if (!gallery) return;

    var scroller = gallery.querySelector('slideshow-slides');
    if (!scroller) return;

    var targetIndex = getColorTargetIndex(scroller, version);
    if (targetIndex < 0) return;

    waitAndScrollToSlide(gallery, scroller, targetIndex, mySession);
  }, delay);
}

// ── Retry scroll until gallery has painted (offsetWidth > 0) ─────────────────
function waitAndScrollToSlide(gallery, scroller, targetIndex, sessionId) {
  var attempts = 0;

  function attempt() {
    // Abort if a newer scroll has been scheduled
    if (sessionId !== _scrollSessionId) return;

    var slideWidth = scroller.offsetWidth;
    if (!slideWidth || slideWidth < 50) {
      if (attempts++ < 20) setTimeout(attempt, 50); // retry every 50ms, max ~1000ms
      return;
    }

    var targetLeft = targetIndex * slideWidth;
    scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
  }

  attempt();
}

// ── Find slide index for current checked color ───────────────────────────────
function getColorTargetIndex(scroller, version) {
  var checkedColor = document.querySelector('.variant__input--color-swatch:checked');
  if (!checkedColor) return -1;

  var isLimited = version.indexOf('limited') !== -1;
  var attr = isLimited ? 'data-limited-gallery' : 'data-classic-gallery';
  var matchFilename = (checkedColor.getAttribute(attr) || '').split('?')[0];
  if (!matchFilename) return -1;

  var targetIndex = -1;
  Array.from(scroller.querySelectorAll(':scope > *')).forEach((slide, i) => {
    var img = slide.querySelector('img');
    if (!img) return;
    var src = (img.getAttribute('src') || img.getAttribute('data-src') || '').split('?')[0];
    if (src.includes(matchFilename) || matchFilename.includes(src.split('/').pop())) {
      targetIndex = i;
    }
  });

  return targetIndex;
}

// ── Get gallery by version string ────────────────────────────────────────────
function getGalleryByVersion(version) {
  var galleryObj = document.querySelector('.product-information .product-information__media');
  if (!galleryObj) return null;

  return (version === 'classic')
    ? galleryObj.querySelector('.original-gallery')
    : galleryObj.querySelector('.abtest-gallery');
}

// ── Read current checked version ─────────────────────────────────────────────
function getCurrentVersion() {
  var version = '';
  var vw = document.querySelector('.product-details .variant-picker__form .fieldset-version');
  if (vw) {
    var vi = vw.querySelector('.variant__input--other-swatch:checked');
    if (vi) version = handleize(vi.value);
  }
  if(version==""){
    version = 'classic';
  }
  return version;
}

// ─────────────────────────────────────────────
// syncColorUI
// ─────────────────────────────────────────────

function syncColorUI(selectColorVal, selectColorImg) {
  var timeoutsec = 300;

  qsa('.apex-custom-product-box-1 .variant-input-wrap-color label').forEach((el) => {
    el.classList.remove('active');
  });
  qsa('.apex-custom-product-box-2 .variant-input-wrap-color label').forEach((el) => {
    el.classList.remove('active');
  });

  var box2Match = qs('.apex-custom-product-box-2 .variant-input-wrap-color [data-value="' + selectColorVal + '"]');
  if (box2Match) {
    var box2Label = box2Match.querySelector('label');
    if (box2Label) box2Label.classList.add('active');
    var box2ColorLabel = qs('.apex-custom-product-box-2 .variant__label [data-variant-color-label]');
    if (box2ColorLabel) box2ColorLabel.textContent = selectColorVal;
  }

  var box1Match = qs('.apex-custom-product-box-1 .variant-input-wrap-color [data-value="' + selectColorVal + '"]');
  if (box1Match) {
    var box1Label = box1Match.querySelector('label');
    if (box1Label) box1Label.classList.add('active');
    var box1ColorLabel = qs('.apex-custom-product-box-1 .variant__label [data-variant-color-label]');
    if (box1ColorLabel) box1ColorLabel.textContent = selectColorVal;
  }

  var box3Img = qs('.product_bundle_selector .strap_product_main .bsc_product_banner img');
  if (box3Img && selectColorImg) box3Img.setAttribute('src', selectColorImg);

  var box3Title = qs('.apex-custom-product-box-3 .variant-popdown-color .variant-popdown-select .varianttitle-color');
  if (box3Title) box3Title.textContent = selectColorVal;

  // Capture version NOW before setTimeout
  var checkVersion = getCurrentVersion();
  // Schedule scroll — galleryObserver will cancel+reschedule if gallery re-renders first
  scheduleColorSlideScroll(300);

  // Re-apply gallery visibility after color change
  setTimeout(() => {
    limitedEditionGalleryChange(checkVersion);
  }, 500);
}

// ─────────────────────────────────────────────
// syncSizeUI
// ─────────────────────────────────────────────

function syncSizeUI(selectSizeVal) {
  qsa('.apex-custom-product-box-1 .variant-input-wrap-size label').forEach((el) => {
    el.classList.remove('active');
  });
  qsa('.apex-custom-product-box-2 .variant-input-wrap-size label').forEach((el) => {
    el.classList.remove('active');
  });

  var box2Match = qs('.apex-custom-product-box-2 .variant-input-wrap-size [data-value="' + selectSizeVal + '"]');
  if (box2Match) {
    var box2Label = box2Match.querySelector('label');
    if (box2Label) box2Label.classList.add('active');
  }

  var box1Match = qs('.apex-custom-product-box-1 .variant-input-wrap-size [data-value="' + selectSizeVal + '"]');
  if (box1Match) {
    var box1Label = box1Match.querySelector('label');
    if (box1Label) box1Label.classList.add('active');
  }

  var box3SizeTitle = qs('.apex-custom-product-box-3 .variant-popdown-size .variant-popdown-select .varianttitle-size');
  if (box3SizeTitle) box3SizeTitle.textContent = selectSizeVal;
}

// ─────────────────────────────────────────────
// DOMContentLoaded — swatch listeners
// ─────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {

  qsa('.variant__input--color-swatch').forEach((input) => {
    input.addEventListener('change', function () {
      var selectColorVal = this.value;
      var parentLabel = this.closest('label') || this.parentElement;
      var imgEl = parentLabel ? parentLabel.querySelector('img') : null;
      var selectColorImg = imgEl ? imgEl.getAttribute('src') : null;
      syncColorUI(selectColorVal, selectColorImg);
      stickyProductInfoset();
      bundleProductInfoset();
    });
  });

  var checkedColor = qs('.product-information__grid .product-details .variant__input--color-swatch:checked');
  if (checkedColor && checkedColor.value !== '') {
    syncColorUI(checkedColor.value, checkedColor.getAttribute('data-img'));
  }

  qsa('.variant__input--other-swatch').forEach((input) => {
    input.addEventListener('change', function () {
      syncSizeUI(this.value);
      stickyProductInfoset();
      bundleProductInfoset();

      var checkedColor = qs('.product-information__grid .product-details .variant__input--color-swatch:checked');
      if (checkedColor) {
        var parentLabel = checkedColor.closest('label') || checkedColor.parentElement;
        var imgEl = parentLabel ? parentLabel.querySelector('img') : null;
        var selectColorImg = imgEl ? imgEl.getAttribute('src') : null;
        syncColorUI(checkedColor.value, selectColorImg);
      }
    });
  });

  var checkedSize = qs('.fieldset-size .variant-option__button-label .variant__input--color-swatch:checked');
  if (checkedSize && checkedSize.value !== '') {
    syncSizeUI(checkedSize.value);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.variant-popdown')) {
      qsa('.variant-popdown-list').forEach((el) => {
        el.style.display = 'none';
      });
    }
  });

  qsa('.variant-popdown-select').forEach((btn) => {
    btn.addEventListener('click', function (event) {
      qsa('.variant-popdown-list').forEach((el) => {
        el.style.display = 'none';
      });

      if (this.classList.contains('d-open')) {
        this.classList.remove('d-open');
      } else {
        this.classList.add('d-open');
        var currentSeclVal = this.getAttribute('data-val');
        var titleEl = qs('.varianttitle-' + currentSeclVal);
        if (titleEl) titleEl.style.display = '';
        event.stopPropagation();
      }
    });
  });

});

// ─────────────────────────────────────────────
// DOMContentLoaded – bundle init
// ─────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {

  // Capped: on non-bundle pages this would otherwise poll 10x a second forever.
  var proBundleAttempts = 0;

  var proBundleLoad = setInterval(() => {
    if (++proBundleAttempts > 200) {
      clearInterval(proBundleLoad);
      return;
    }

    if (bundleActiveVersion()) {
      bundleProductInfoset();

      var bundleContent    = qs('.bundle_selector_content');
      var strapAccessories = qs('.bundle_selector_option.option_strap_accessories .bundle_selector_label');
      var singleStrap      = qs('.bundle_selector_option.option_single_strap .bundle_selector_label');

      if (!bundleContent) return;

      function resetClasses() {
        bundleContent.classList.remove('strap_accessories_active', 'single_strap_active');
      }

      if (strapAccessories) {
        strapAccessories.addEventListener('click', () => {
          resetClasses();
          bundleContent.classList.add('strap_accessories_active');
          bundleProductInfoset();
        });
      }

      if (singleStrap) {
        singleStrap.addEventListener('click', () => {
          resetClasses();
          bundleContent.classList.add('single_strap_active');
        });
      }

      clearInterval(proBundleLoad);
    }
  }, 100);

  if (bundleActiveVersion()) {
    var selectClass = '.bundle_selector_wrapper .strap_accessories_item';
    if (
      document.body.classList.contains('bundle_selector_vtwo') ||
      document.body.classList.contains('bundle_selector_vthree')
    ) {
      selectClass = '.bundle_selector_wrapper .bsc_strap_size_select';
    }

    // Capped: products without a colour option would otherwise poll forever.
    var interColorAttempts = 0;

    var interColorId = setInterval(() => {
      if (++interColorAttempts > 20) {
        clearInterval(interColorId);
        return;
      }

      var hasVariant = qs(selectClass + ' .bsc_select_variant');
      var hasColor   = qs('.variant-input-wrap-color [name="Color"]');
      if (hasVariant && hasColor) {
        colorWiseAccessories();
        clearInterval(interColorId);
      }
    }, 1000);

    var getVersion = getCurrentVersion();
    limitedEditionGalleryChange(getVersion);
  }
});

// ─────────────────────────────────────────────
// Delegated event listeners
// ─────────────────────────────────────────────

document.addEventListener('change', (e) => {
  var target = e.target;
  if (
    target.matches(
      '.product_bundle_selector .strap_product_cover .bsc_select_variant, ' +
      '.product_bundle_selector .bsc_strap_size_select .bsc_select_variant'
    )
  ) {
    strapAccessoriesSet(target.closest('select') || target);
  }
});

document.addEventListener('change', (e) => {
  var target = e.target;
  if (
    target.matches(
      '.bundle_selector_wrapper .strap_accessories_item .watch_cover_dropdown, ' +
      '.bundle_selector_wrapper .bsc_strap_size_select .watch_cover_dropdown'
    )
  ) {
    var selected = target.options[target.selectedIndex];
    var getVariantImage = selected ? selected.getAttribute('data-color-img') : null;
    if (
      getVariantImage &&
      (
        document.body.classList.contains('bundle_selector_vone') ||
        document.body.classList.contains('bundle_selector_vtwo') ||
        document.body.classList.contains('bundle_selector_vthree')
      )
    ) {
      var bannerImg = qs('.bundle_selector_wrapper .strap_product_cover .bsc_product_banner img');
      if (bannerImg) bannerImg.setAttribute('src', getVariantImage);
    }
  }
});

document.addEventListener('click', (e) => {
  if (
    e.target.closest('.page-content--product .variant-input-wrap-color') ||
    e.target.closest('.page-content--product .variant-input-wrap-size')
  ) {
    var colorRadio = qs('.variant-input-wrap-color [name="Color"]');
    var sizeRadio  = qs('.variant-input-wrap-color [name="Size"]');
    if (colorRadio || sizeRadio) {
      colorWiseAccessories();
    }
  }
});

// ─────────────────────────────────────────────
// strapAccessoriesSet
// ─────────────────────────────────────────────

function strapAccessoriesSet(selectEl) {
  var selectObj = selectEl && selectEl.tagName === 'SELECT'
    ? selectEl
    : selectEl && selectEl.querySelector
      ? selectEl.querySelector('select')
      : null;

  if (!selectObj) return;

  var selected     = selectObj.options[selectObj.selectedIndex];
  var mainPrice    = selected.getAttribute('data-price');
  var availProduct = selected.getAttribute('data-avail');

  if (!availProduct) return;

  var bundleSelector = qs('.product_bundle_selector');
  if (!bundleSelector) return;

  var priceObj = bundleSelector.querySelector('.strap_accessories_item');
  if (!priceObj) return;

  var salePrices = priceObj.querySelectorAll('.bsc_product_sale');
  if (salePrices.length > 1) {
    salePrices[1].textContent = mainPrice;
  }

  var comparePrice = selected.getAttribute('data-cprice');
  if (comparePrice) {
    var comparePrices = priceObj.querySelectorAll('.bsc_product_compare');
    if (comparePrices.length > 1) comparePrices[1].textContent = comparePrice;
  }

  var getSize = selected.getAttribute('data-size');
  if (getSize) {
    var variantSelectCover = priceObj.querySelector('.accessories_product .bsc_variant_select_cover');
    if (variantSelectCover) variantSelectCover.textContent = getSize;

    if (/series\s*10/i.test(getSize)) {
      getSize = getSize.replace(/\s*&.*?\)/, ')');
    }

    var protectOption = priceObj.querySelector(
      '.strap_accessories_product .protect_cover_dropdown option[data-size="' + getSize + '"]'
    );
    if (protectOption) {
      protectOption.selected = true;
      protectOption.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

// ─────────────────────────────────────────────
// colorWiseAccessories
// ─────────────────────────────────────────────

function colorWiseAccessories() {
  var colorInput = qs('.product-information__grid .product-details .variant__input--color-swatch:checked');
  if (!colorInput) return;

  var getColorVal = colorInput.value;
  var getSizeVal  = '';

  var sizeInput = qs('.fieldset-size .variant-option__button-label .variant__input--color-swatch:checked');
  if (sizeInput) {
    getSizeVal = sizeInput.value;
    if (/series\s*10/i.test(getSizeVal)) {
      getSizeVal = getSizeVal.replace(/\s*&.*?\)/, ')');
    }
    getSizeVal = getSizeVal.split('/')[0].trim();
  }

  var selectClass = document.body.classList.contains('bundle_selector_vtwo') ||
    document.body.classList.contains('bundle_selector_vthree')
    ? '.bundle_selector_wrapper .bsc_strap_size_select'
    : '.bundle_selector_wrapper .strap_accessories_item';

  if (!getColorVal) return;

  var productSection  = qs('.product-information .product-information__grid');
  var getbundleHandle = productSection ? (productSection.getAttribute('data-product-handle') || '') : '';

  getColorVal = handleize(getColorVal);

  if (getbundleHandle === 'diva-strap') {
    var colorMap = { 'peachblow': 'gold', 'pink-petal': 'starlight', 'cloud-white': 'starlight' };
    if (colorMap[getColorVal]) {
      var testSelect = qs(selectClass + ' .bsc_select_variant');
      if (testSelect && !testSelect.querySelector('option[data-color-handle="' + getColorVal + '"]')) {
        getColorVal = colorMap[getColorVal];
      }
    }
  } else if (getbundleHandle === 'bijou-apple-watch-strap') {
    var bijouMap = {
      'white-and-silver': 'silver-gem', 'black-and-silver': 'silver-gem',
      'white-and-gold': 'gold', 'black-and-gold': 'gold'
    };
    if (bijouMap[getColorVal]) {
      var testSelect = qs(selectClass + ' .bsc_select_variant');
      if (testSelect && !testSelect.querySelector('option[data-color-handle="' + getColorVal + '"]')) {
        getColorVal = bijouMap[getColorVal];
      }
    }
  } else if (getbundleHandle === 'key-to-my-luck-strap') {
    var luckMap = { 'starlight-and-white': 'white-and-silver', 'starlight-and-black': 'black-and-silver' };
    if (luckMap[getColorVal]) {
      var testSelect = qs(selectClass + ' .bsc_select_variant');
      if (testSelect && !testSelect.querySelector('option[data-color-handle="' + getColorVal + '"]')) {
        getColorVal = luckMap[getColorVal];
      }
    }
  } else {
    if (getColorVal === 'rose-gold') {
      var testSelect = qs(selectClass + ' .bsc_select_variant');
      if (testSelect && !testSelect.querySelector('option[data-color-handle="rose-gold"]')) {
        getColorVal = 'sunset-rose-gold';
      }
    } else if (getColorVal === 'space-gem') {
      getColorVal = 'black';
    }
  }

  qsa('.product_bundle_selector .bsc_select_variant.watch_cover_dropdown').forEach((item) => {
    var select = item;
    if (!select) return;

    var option = getSizeVal
      ? select.querySelector('option[data-color-handle="' + getColorVal + '"][data-size="' + getSizeVal + '"]')
      : select.querySelector('option[data-color-handle="' + getColorVal + '"]');

    if (option && select.value !== option.value) {
      [...select.options].forEach(o => o.selected = false);
      const target = [...select.options].find(o => o.value === option.value);
      if (target) {
        target.selected = true;
        target.setAttribute('selected', 'selected');
      }
      var variantImage = option.getAttribute('data-color-img');
      if (variantImage) {
        var bannerImg = qs('.strap_product_cover .bsc_product_banner img');
        if (bannerImg) bannerImg.setAttribute('src', variantImage);
      }
    }
  });

  if (getSizeVal != '' && getSizeVal != undefined && getSizeVal != null) {
    qsa('.product_bundle_selector .bsc_select_variant.protect_cover_dropdown').forEach((item) => {
      var select = item;
      if (!select) return;

      var option = getSizeVal
        ? select.querySelector('option[data-size="' + getSizeVal + '"]')
        : null;

      if (option && select.value !== option.value) {
        [...select.options].forEach(o => o.selected = false);
        const target = [...select.options].find(o => o.value === option.value);
        if (target) {
          target.selected = true;
          target.setAttribute('selected', 'selected');
        }
      }
    });
  }
}

// ─────────────────────────────────────────────
// preparePDPBundle
// ─────────────────────────────────────────────

function preparePDPBundle() {
  var bundleData = [];

  function addVariantData(selectEl) {
    if (!selectEl || selectEl.tagName !== 'SELECT') return;
    if (selectEl.selectedIndex < 0) return;

    var selected = selectEl.options[selectEl.selectedIndex];
    if (!selected) return;

    var variantId = selected.value;
    if (!variantId) return;

    var avail = selected.getAttribute('data-avail');
    if (!avail) return;

    if (!bundleData.some((item) => item.variant_id == variantId)) {
      bundleData.push({
        product_title:  selected.getAttribute('data-ptitle'),
        variant_id:     variantId,
        variant_name:   selected.textContent.trim(),
        variant_handle: selected.getAttribute('data-handle'),
        variant_image:  selected.getAttribute('data-img'),
        variant_price:  selected.getAttribute('data-oprice')
      });
    }
  }

  if (document.body.classList.contains('bundle_selector_vone')) {
    qsa('.product_bundle_selector .strap_accessories_active .bsc_select_variant.watch_cover_dropdown').forEach(addVariantData);
    qsa('.product_bundle_selector .strap_accessories_active .strap_accessories_product .protect_cover_dropdown').forEach(addVariantData);
  } else if (
    document.body.classList.contains('bundle_selector_vtwo') ||
    document.body.classList.contains('bundle_selector_vthree')
  ) {
    qsa('.product_bundle_selector .bsc_strap_size_select .bsc_select_variant').forEach(addVariantData);
    qsa('.product_bundle_selector .strap_accessories_product .protect_cover_dropdown').forEach(addVariantData);
  }

  return bundleData;
}

// ─────────────────────────────────────────────
// bundlePriceTotal
// ─────────────────────────────────────────────


//handleWiseGetPriceMain Product
function buildHandleFromCheckedRadios() {
  var fieldset = qsa('.pdp--main-product-section .product-details variant-picker fieldset');
  var parts = [];

  fieldset.forEach((fs) => {
    var checkedInput = fs.querySelector('input[type="radio"]:checked');
    if (!checkedInput) return;
    parts.push(handleize(checkedInput.value));
  });

  var builtHandle = parts.join('-');
  builtHandle = builtHandle.replace(/-+/g, '-').replace(/^-+|-+$/g, '');

  return builtHandle;
}

function getMainProductVariantOption() {
  var builtHandle = buildHandleFromCheckedRadios();

  var mainSelect = qs('.product-single__variants');
  if (!mainSelect) return null;

  var matchedOption = null;

  Array.prototype.forEach.call(mainSelect.options, (opt) => {
    if (opt.getAttribute('data-handle') === builtHandle) {
      matchedOption = opt;
    }
  });

  return matchedOption;
}

function getFallbackVariantOption() {
  var mainSelect = qs('.pdp--main-product-section .product-details .main_product_variant');
  if (!mainSelect) return null;

  var fallbackOption = null;

  Array.prototype.forEach.call(mainSelect.options, function (opt) {
    if (opt.getAttribute('data-available') === 'true' && !fallbackOption) {
      fallbackOption = opt;
    }
  });

  return fallbackOption || mainSelect.options[0] || null;
}

function bundlePriceTotal() {
  var totalPrice  = 0;
  var totalCPrice = 0;
  var bundleData1 = [];

  var bundleSelector = qs('.product_bundle_selector');
  if (!bundleSelector) return;

  var activeItems = qsa('.product_bundle_selector .bsc_variant_dropdown .bsc_select_variant');

  activeItems.forEach(function (selectEl) {
    var selected   = selectEl.options[selectEl.selectedIndex];
    var variantVal = selected ? selected.value : '';
    if (!variantVal) return;

    var price  = selected.getAttribute('data-oprice');
    var cprice = selected.getAttribute('data-ocprice');

    if (!bundleData1.includes(variantVal)) {
      bundleData1.push(variantVal);
      totalPrice  += parseFloat(price)  || 0;
      if (cprice) totalCPrice += parseFloat(cprice) || 0;
    }
  });

  // main product ni matched option select thi levu, [name="id"] nathi lidhu have
  var matchedMainOption = getMainProductVariantOption();
  var mainPrice  = null;
  var mainCPrice = null;

  if (matchedMainOption) {
    mainPrice  = matchedMainOption.getAttribute('data-oprice');
    mainCPrice = matchedMainOption.getAttribute('data-ocprice');
  } else {
    var fallbackOption = getFallbackVariantOption();
    //console.log("fallbackOption",fallbackOption);
    if (fallbackOption) {
      mainPrice  = fallbackOption.getAttribute('data-oprice');
      mainCPrice = fallbackOption.getAttribute('data-ocprice');
    }
  }

  if (mainPrice) {
    totalPrice  += parseFloat(mainPrice)  || 0;
    if (mainCPrice) totalCPrice += parseFloat(mainCPrice) || 0;

    var salePrices = bundleSelector.querySelectorAll('.bsl_prices_inner .bsl_price_sale');
    if (salePrices.length > 0) {
      bundleSelector.querySelectorAll('.bs_label_prices .bsl_price_sale')[0]
        .textContent = Shopify.formatMoney(mainPrice);
    }

    var comparePrices = bundleSelector.querySelectorAll('.bsl_prices_inner .bsl_price_compare');
    if (mainCPrice && comparePrices.length > 0) {
      bundleSelector.querySelectorAll('.bs_label_prices .bsl_prices_inner .bsl_price_compare')[0]
        .textContent = Shopify.formatMoney(mainCPrice);
    }

    if (salePrices.length > 0) {
      bundleSelector.querySelectorAll('.bsc_product_prices .bsc_product_sale')[0]
        .textContent = Shopify.formatMoney(mainPrice);
    }

    if (mainCPrice && comparePrices.length > 0) {
      bundleSelector.querySelectorAll('.bsc_product_prices .bsc_product_compare')[0]
        .textContent = Shopify.formatMoney(mainCPrice);
    }
  }

  if (totalPrice !== 0) {
    var totalSaleEls = bundleSelector.querySelectorAll('.bsl_prices_inner .bsl_price_sale');
    if (totalSaleEls.length > 0) {
      bundleSelector.querySelectorAll('.bs_label_prices .bsl_price_sale')[1]
        .textContent = Shopify.formatMoney(totalPrice);
    }
  }

  if (totalCPrice !== 0) {
    var totalCompareEls = bundleSelector.querySelectorAll('.bsl_prices_inner .bsl_price_compare');
    if (totalCompareEls.length > 0) {
      var getOff = getDiscountPercent(totalCPrice, totalPrice);

      var headingSave = qs('.bs_label_heading_bundle .bsl_heading_save', bundleSelector);
      if (headingSave) headingSave.textContent = 'Save ' + getOff + '%';

      var pricesSaveLabel = qs('.bs_label_prices .bsl_prices_savelabel', bundleSelector);
      if (pricesSaveLabel) pricesSaveLabel.textContent = 'Save ' + getOff + '%';

      bundleSelector.querySelectorAll('.bs_label_prices .bsl_prices_inner .bsl_price_compare')[1]
        .textContent = Shopify.formatMoney(totalCPrice);
    }
  }
}

// radio change thi price update trigger karva
document.addEventListener('change', (e) => {
  if (e.target.closest('.pdp--main-product-section variant-picker fieldset')) {
    bundlePriceTotal();
  }
});

// ─────────────────────────────────────────────
// bundleProductInfoset
// ─────────────────────────────────────────────

function bundleProductInfoset() {
  setTimeout(() => {
    var checkedColor = qs('.page-content--product .variant-input-wrap-color input[name="Color"]:checked');
    if (!checkedColor) return;

    var variantInput = checkedColor.closest('.variant-input');
    var imgEl        = variantInput ? variantInput.querySelector('.variant__button-label img') : null;
    var imgSrc       = imgEl ? imgEl.getAttribute('src') : null;

    if (!imgSrc) return;

    var getColor = checkedColor.value;

    var pdpSection = qs('.pdp--main-product-section');
    if (!pdpSection) return;

    if (pdpSection.querySelector('.product_bundle_selector')) {
      var strapBannerImg = qs('.bs_content_item.strap_accessories_item .bsc_product_banner img');
      if (strapBannerImg) strapBannerImg.setAttribute('src', imgSrc);

      var bscVariantSelect = pdpSection.querySelector('.bsc_product_content .bsc_variant_select');
      if (bscVariantSelect) {
        var selectedVerison = '';
        var versionSwatch   = pdpSection.querySelector('.variant-input-wrap-version');
        if (versionSwatch) {
          var versionChecked = versionSwatch.querySelector('[type="radio"]:checked');
          if (versionChecked) selectedVerison = versionChecked.value;
        }

        var stringappend = '';
        if (selectedVerison && getColor) {
          stringappend = selectedVerison + ' - ' + getColor;
        } else if (getColor) {
          stringappend = getColor;
        }

        var sizeSwatch = pdpSection.querySelector('.variant-input-wrap-size');
        if (sizeSwatch) {
          var sizeChecked = sizeSwatch.querySelector('[type="radio"]:checked');
          if (sizeChecked) stringappend += ' - ' + sizeChecked.value;
        }

        bscVariantSelect.textContent = stringappend;
      }
    }

    bundleSetPrice();
    bundlePriceTotal();
    var strapSelectObj = qs('.product_bundle_selector .bs_content_item.strap_accessories_item .bsc_select_variant');
    if (strapSelectObj) {
      strapAccessoriesSet(strapSelectObj);
    }
  }, 100);
}

// ─────────────────────────────────────────────
// bundleSetPrice
// ─────────────────────────────────────────────

function bundleSetPrice() {
  var pdpSection = qs('.pdp--main-product-section');
  if (!pdpSection) return;

  var priceObj = pdpSection.querySelector('.product_main_price');
  if (!priceObj || !priceObj.querySelector('.original___price')) return;

  var objPrice = pdpSection.querySelector('.product_bundle_selector .bsc_product_content');
  if (!objPrice) return;

  var mainPriceEl = priceObj.querySelector('.original___price');
  if (mainPriceEl) {
    var mainPrice = mainPriceEl.textContent;
    if (mainPrice) {
      var saleEl = objPrice.querySelector('.bsc_product_sale');
      if (saleEl) saleEl.textContent = mainPrice;
    }
  }

  var comparePriceEl = priceObj.querySelector('.compare___price');
  var compareEl      = objPrice.querySelector('.bsc_product_compare');

  if (comparePriceEl) {
    if (compareEl) compareEl.style.display = '';
    var comparePrice = comparePriceEl.textContent;
    if (comparePrice && compareEl) {
      compareEl.textContent = comparePrice;
    }
  } else {
    if (compareEl) compareEl.style.display = 'none';
  }
}

// ─────────────────────────────────────────────
// stickyProductInfoset
// ─────────────────────────────────────────────

function stickyProductInfoset() {
  colorWiseAccessories();
  setTimeout(() => {

    var stickyBar = document.querySelector('.sticky_product_bar');
    if (!stickyBar) return;

    var checkedColor = document.querySelector('.page-content--product .variant-input-wrap-color input[name="Color"]:checked');
    if (!checkedColor) return;

    var variantInput = checkedColor.closest('.variant-input');
    var imgEl = variantInput ? variantInput.querySelector('.variant__button-label img') : null;
    var imgSrc = imgEl ? imgEl.getAttribute('src') : null;
    if (!imgSrc) return;


    var getColor = checkedColor.value;

    var stickyBannerImg = stickyBar.querySelector('.sticky_product_banner img');
    if (stickyBannerImg) stickyBannerImg.setAttribute('src', imgSrc);

    var bodyClasses = document.body.classList;

    if (!bodyClasses.contains('variant-show-title') && !bodyClasses.contains('variant-selected')) {
      var variantStr = '';

      if (getColor) {
        variantStr +=
          '<div class="sp_variant_item">' +
          '<span class="sp_variant_label">Color -</span>' +
          '<span class="sp_variant_select">' + getColor + '</span>' +
          '</div>';
      }

      var otherSwatches = document.querySelectorAll('.page-content--product .variant__input--other-swatch:checked');
      otherSwatches.forEach((swatch) => {
        var nameAttr    = swatch.getAttribute('name');
        var valueSwatch = swatch.value;
        variantStr +=
          '<div class="sp_variant_item">' +
          '<span class="sp_variant_label">' + nameAttr + ' -</span>' +
          '<span class="sp_variant_select">' + valueSwatch + '</span>' +
          '</div>';
      });

      if (variantStr) {
        var variantBox = stickyBar.querySelector('.sticky_product_details .sticky_product_variantbox');
        if (variantBox) variantBox.innerHTML = variantStr;
      }

    } else if (bodyClasses.contains('variant-show-title')) {
      var productObj = document.querySelector('.pdp--main-product-section');
      if (!productObj || !productObj.querySelector('.sticky_product_bar')) return;

      var spVariantSelects = productObj.querySelectorAll('.sticky_product_bar .sp_variant_select');
      if (!spVariantSelects.length) return;

      var selectedVersion = '';
      var versionSwatch = productObj.querySelector('.variant-input-wrap-version');
      if (versionSwatch) {
        var versionChecked = versionSwatch.querySelector('[type="radio"]:checked');
        if (versionChecked) {
          selectedVersion = versionChecked.value;
        }
      }

      var stringappend = '';
      if (selectedVersion && getColor) {
        stringappend = selectedVersion + ' - ' + getColor;
      } else if (getColor) {
        stringappend = getColor;
      }

      var sizeSwatch = productObj.querySelector('.variant-input-wrap-size');
      if (sizeSwatch) {
        var sizeChecked = sizeSwatch.querySelector('[type="radio"]:checked');
        if (sizeChecked) {
          stringappend += ' - ' + sizeChecked.value;
        }
      }

      spVariantSelects[0].textContent = stringappend;

    } else if (bodyClasses.contains('variant-selected')) {
      var productObj = document.querySelector('.pdp--main-product-section');
      if (!productObj || !productObj.querySelector('.sticky_product_bar')) return;

      var selectedVariantOption = productObj.querySelector('.product-single__variants option:selected');
      var getSelectedVariant = selectedVariantOption ? selectedVariantOption.value : '';

      var spDropdown = productObj.querySelector('.sticky_product_bar .sp_variant_dropdown');
      if (spDropdown) {
        var dropdownSelect = spDropdown.querySelector('select');
        if (dropdownSelect) dropdownSelect.value = '';
        if (getSelectedVariant && dropdownSelect) {
          dropdownSelect.value = getSelectedVariant;
        }
      }
    }

  }, 500);
}

// ─────────────────────────────────────────────
// Bundle ATC submit start
// ─────────────────────────────────────────────


function patchBundleRemove() {
  var cartComp = document.querySelector('cart-items-component');
  if (!cartComp) return false;

  var proto = Object.getPrototypeOf(cartComp);
  if (proto._bundleRemovePatched) return true;

  var originalFn = proto.onLineItemRemove;

  proto.onLineItemRemove = function (lineIndex) {
    cartLoadingState(true);

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        var item = cart.items[lineIndex - 1];

        if (
          item &&
          item.properties &&
          item.properties._is_bundle_parent === 'true'
        ) {
          var bundleId  = item.properties._bundle_id;
          var parentKey = item.key;

          var keysToRemove = [parentKey];
          cart.items.forEach((cartItem) => {
            if (
              cartItem.properties &&
              cartItem.properties._is_bundle_child === 'true' &&
              cartItem.properties._parent_bundle === bundleId
            ) {
              keysToRemove.push(cartItem.key);
            }
          });

          var updates = {};
          keysToRemove.forEach((key) => { updates[key] = 0; });

          fetch('/cart/update.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ updates: updates })
          })
          .then((r) => r.json())
          .then(() => {
            refreshCartDrawer();
          })
          .catch((err) => {
            console.error('❌ Bundle remove error:', err);
            cartLoadingState(false); // ✅
            originalFn.call(this, lineIndex);
          });

          return;
        }

        // ✅ Non-bundle: hide loader before handing off to Horizon
        cartLoadingState(false);
        originalFn.call(this, lineIndex);
      })
      .catch(() => {
        cartLoadingState(false); // ✅
        originalFn.call(this, lineIndex);
      });
  };

  proto._bundleRemovePatched = true;
  return true;
}

function cartLoadingState(show) {
  var loader  = document.querySelector('.cart-drawer_loading-loader');
  var overlay = document.querySelector('.cart-drawer_loading-overlay');

  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'cart-drawer_loading-overlay';
    var cartDrawer = document.querySelector('.cart-drawer, cart-drawer-component');
    if (cartDrawer) cartDrawer.appendChild(overlay);
  }

  if (loader)  loader.style.display  = show ? 'block' : 'none';
  if (overlay) overlay.style.display = show ? 'block' : 'none';
}

function refreshCartDrawer(openDrawer) {
  var cartEl    = document.querySelector('cart-items-component');
  var sectionId = cartEl?.getAttribute('data-section-id') || '';
  if (!sectionId) return;

  cartLoadingState(true);

  fetch('/?sections=' + encodeURIComponent(sectionId))
    .then((r) => r.json())
    .then((sections) => {
      var freshHTML = sections[sectionId];
      if (!freshHTML || !cartEl) {
        cartLoadingState(false); //
        return;
      }

      var parser      = new DOMParser();
      var freshDoc    = parser.parseFromString(freshHTML, 'text/html');
      var freshCartEl = freshDoc.querySelector('cart-items-component');
      if (freshCartEl) cartEl.innerHTML = freshCartEl.innerHTML;

      // Bubble + cart-icon class update
      var newBubble = freshDoc.querySelector('#cart-bubble-text');
      var oldBubble = document.querySelector('#cart-bubble-text');
      if (newBubble && oldBubble) {
        oldBubble.innerHTML = newBubble.innerHTML;
        var countEl  = oldBubble.querySelector('.cart-bubble__text-count');
        var count    = countEl ? (parseInt(countEl.textContent.trim()) || 0) : 0;
        var cartIcon = document.querySelector('cart-icon');
        if (cartIcon) {
          cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        }
      }

      // Hide loader immediately after content update — BEFORE drawer logic
      // Fixes: empty cart case where Horizon closes drawer before setTimeout fires
      cartLoadingState(false);

      if (openDrawer !== false) {
        setTimeout(() => {
          var cartBtn = document.querySelector('button.header-actions__action[aria-label="Cart"]');
          var isOpen  = document.querySelector('.cart-drawer[open], .cart-drawer.is-open, dialog[open]');
          if (!isOpen && cartBtn) {
            cartBtn.click();
          } else {
            // Drawer is already open - nothing to do.
          }
        }, 150);
      }
    })
    .catch(() => {
      cartLoadingState(false); //
    });
}
// ── MutationObserver patch ────────────────────────────────────────────────────
function initBundleRemovePatch() {
  if (patchBundleRemove()) return;
  var _patchObserver = new MutationObserver(() => {
    if (patchBundleRemove()) _patchObserver.disconnect();
  });

  _patchObserver.observe(document.body, { childList: true, subtree: true });
}


// Capture phase par document level - Horizon's product-form-component
document.addEventListener('submit', (e) => {
  var productForm = e.target.closest('form[action="/cart/add"]');
  if (!productForm) return;

  var bundleSelector = document.querySelector('.product_bundle_selector');
  if (!bundleSelector) return;

  // ★ FIX: block display:none (ya hidden) hoy to default flow j chalva do
  var isVisible = !!(bundleSelector.offsetWidth || bundleSelector.offsetHeight || bundleSelector.getClientRects().length);
  if (!isVisible) return;

  var bundleCheckbox = bundleSelector.querySelector('[name="bundle_selector"]:checked');
  if (!bundleCheckbox) return;
  if (bundleCheckbox.value !== 'strap_accessories') return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var mainVariantId = parseInt(productForm.querySelector('[name="id"]').value);
  var qty           = parseInt(productForm.querySelector('[name="quantity"]')?.value || 1);
  var bundleData    = preparePDPBundle();
  if (!bundleData.length) return;

  var bundleId = 'BUNDLE_' + mainVariantId;

  var bundleMetaobj     = document.querySelector('.bundle_mt_fields');
  var bundleImage       = bundleMetaobj?.getAttribute('bundle-image') || '';
  var bundleTitle       = bundleMetaobj?.getAttribute('bundle-title') || '';
  var bundleDescription = bundleMetaobj?.value || '';

  var itemMeta = {};
  bundleData.forEach((item, index) => {
    itemMeta['_Item ' + (index + 1)] = [
      item.product_title,
      item.variant_name,
      item.variant_image,
      item.variant_price,
      item.variant_handle
    ].join('#@#');
  });

  var parentItem = {
    id:       mainVariantId,
    quantity: qty,
    properties: Object.assign({
      _bundle_id:          bundleId,
      _is_bundle_parent:   'true',
      _bundle_image:       bundleImage,
      _bundle_title:       bundleTitle,
      _bundle_description: bundleDescription
    }, itemMeta)
  };

  var sellingPlan = productForm.querySelector('[name="selling_plan"]')?.value;
  if (sellingPlan && sellingPlan !== '') {
    parentItem.selling_plan = parseInt(sellingPlan);
  }

  var childItems = bundleData.map((item) => ({
      id:       parseInt(item.variant_id),
      quantity: 1,
      properties: {
        _bundle:          'true',
        _is_bundle_child: 'true',
        _parent_bundle:   bundleId
      }
    }));

  var submitBtn = productForm.querySelector('[type="submit"], [name="add"]');
  if (submitBtn) {
    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.classList.add('loading');
  }

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ items: childItems })
  })
  .then((res) => {
    if (!res.ok) return res.json().then((e) => { throw e; });
    return res.json();
  })
  .then(() => fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [parentItem] })
    }))
  .then((res) => {
    if (!res.ok) return res.json().then((e) => { throw e; });
    return res.json();
  })
  .then((cart) => {
    updateCartBubble(cart.item_count);
    setTimeout(() => {
      refreshCartDrawer(true);
    }, 300);
  })
  .catch((err) => {
    console.error('❌ Bundle ATC error:', err);
  })
  .finally(() => {
    if (submitBtn) {
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('loading');
    }
  });

}, true);

// ─────────────────────────────────────────────
// Bundle ATC submit end
// ─────────────────────────────────────────────

/// ─────────────────────────────────────────────
// Bundle Remove Product Start
// ─────────────────────────────────────────────
function qs(selector, parent) {
    return (parent || document).querySelector(selector);
}
function qsa(selector, parent) {
    return Array.from((parent || document).querySelectorAll(selector));
}

function updatecartQuantity(el) {
  var wrapper = el.parentElement.querySelector('.js-qty__num');
  if (!wrapper) return;

  var line;
  if (
      document.body.classList.contains('bundle_selector_vone') ||
      document.body.classList.contains('bundle_selector_vtwo') ||
      document.body.classList.contains('bundle_selector_vthree')
  ) {
      line = wrapper.getAttribute('data-cartvid');
  } else {
      line = wrapper.getAttribute('data-id');
  }
  var dataKey = wrapper.getAttribute('data-id');

  var cartItem = qs('.cart__drawer .cart__item[data-key="' + dataKey + '"]');
  if (cartItem) cartItem.remove();

  fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: 0 })
  })
  .then((res) => {
      if (!res.ok) return res.json().then((e) => { throw e; });
      return res.json();
  })
  .then((cart) => {
      updateCartBubble(cart.item_count);
  })
  .catch(() => {
      setTimeout(() => {
          qsa('.cart__drawer .common-loader-atc.btn--loading').forEach((l) => {
              l.style.display = 'none';
          });
      }, 100);
  });
}

function updateCartBubble(itemCount) {
  var iconCart = document.querySelector('.header-actions__cart-icon');
  if (!iconCart) return;
  var cartBubble = iconCart.querySelector('.cart-bubble');
  if (cartBubble && itemCount==0) {
    cartBubble.classList.add('visually-hidden');
  }else{
    cartBubble.classList.remove('visually-hidden');
  }
}

function syncBundleItems(retryCount) {
  retryCount = retryCount || 0;
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
        var updates = {};

        cart.items.forEach((item, mainIndex) => {
            if (item.properties && item.properties._is_bundle_parent === 'true') {
                var bundleId = item.properties._bundle_id;
                var mainQty = item.quantity;

                cart.items.forEach((child, childIndex) => {
                    if (child.properties && child.properties._parent_bundle == bundleId) {
                        var lineNumber = parseInt(childIndex) + 1;
                        if (child.quantity !== mainQty) {
                            updates[lineNumber] = mainQty;
                        }
                    }
                });
            }

            if (item.properties && item.properties._parent_bundle) {
                var parentBundleId = item.properties._parent_bundle;
                var parentExists = cart.items.some((i) => i.properties &&
                        i.properties._bundle_id == parentBundleId &&
                        i.properties._is_bundle_parent === 'true');
                if (!parentExists) {
                    updates[parseInt(mainIndex) + 1] = 0;
                }
            }
        });

        if (Object.keys(updates).length) {
            var lineUpdates = {};
            Object.keys(updates).forEach((lineNum) => {
                var idx = parseInt(lineNum) - 1;
                var item = cart.items[idx];
                if (item) lineUpdates[item.key] = updates[lineNum];
            });

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    updates: lineUpdates,
                    sections: ['cart-icon-bubble'],
                    sections_url: window.location.pathname
                })
            })
                .then((res) => res.json())
                .then((updatedCart) => {
                    updateCartBubble(updatedCart.item_count);
                    refreshCartDrawer(true);
                })
                .catch((err) => {
                    console.error('Cart update error:', err);
                });
        } else if (retryCount < 2) {
            setTimeout(() => {
                syncBundleItems(retryCount + 1);
            }, 500);
        }
    });
}

document.addEventListener('click', (e) => {
    var removeBtn = e.target.closest('.has_bundle_main_card .bundle_remove');
    if (!removeBtn) return;
    updatecartQuantity(removeBtn);
    setTimeout(() => {
        syncBundleItems();
    }, 1000);
});
// ─────────────────────────────────────────────
// Bundle Remove Product End
// ─────────────────────────────────────────────

// ─────────────────────────────────────────────
// limitedEditionGalleryChange
// ─────────────────────────────────────────────

var limitedEditionTimer = null;

function limitedEditionGalleryChange(getVersion) {
  var versionHandle = handleize(String(getVersion));
  var galleryObj    = document.querySelector('.product-information .product-information__media');

  if (!galleryObj) return;

  var originalGallery = galleryObj.querySelector('.original-gallery');
  var abtestGallery   = galleryObj.querySelector('.abtest-gallery');

  // limited-edition → abtest-gallery, classic → original-gallery
  if (versionHandle === 'limited-edition') {
    if (originalGallery) originalGallery.style.display = 'none';
    if (abtestGallery)   abtestGallery.style.display   = 'block';
  } else {
    if (originalGallery) originalGallery.style.display = 'block';
    if (abtestGallery)   abtestGallery.style.display   = 'none';
  }
}

document.addEventListener('change', (e) => {
  var target = e.target;
  if (!target.matches('.product-details .fieldset-version .variant__input--other-swatch')) return;
  if (document.body.classList.contains('color-variant-wise-gallery')) return;

  var fieldsetVersion = document.querySelector('.product-details .fieldset-version');
  if (!fieldsetVersion) return;

  var hasLabelInfo = fieldsetVersion.querySelector('.variant-option__button-label');
  if (!hasLabelInfo) return;

  if (limitedEditionTimer) {
    clearTimeout(limitedEditionTimer);
    limitedEditionTimer = null;
  }

  limitedEditionTimer = setTimeout(() => {
    var checkedVersion = fieldsetVersion.querySelector('.variant__input--other-swatch:checked');
    var getVersion = checkedVersion ? checkedVersion.value : '';

    var labelSetText = fieldsetVersion.querySelector('.variant-option__swatch-value');
    if (labelSetText) {
      var labelSpan = labelSetText.querySelector('.variant__label-info span');
      if (labelSpan) labelSpan.textContent = getVersion;
    }

    if (getVersion !== '') {
      limitedEditionGalleryChange(getVersion);
      setTimeout(triggerGalleryVideo, 500);
    }
  }, 300);
});

// ─────────────────────────────────────────────
// Video autoplay — mobile slider + desktop grid
// ─────────────────────────────────────────────

function triggerGalleryVideo() {
  var original = document.querySelector('.original-gallery');
  var abtest   = document.querySelector('.abtest-gallery');
  var galleryEl = (abtest && getComputedStyle(abtest).display !== 'none') ? abtest : original;
  if (!galleryEl) return;

  var scroller = galleryEl.querySelector('slideshow-slides');
  if (!scroller) return;

  var slides = Array.from(scroller.querySelectorAll(':scope > *'));
  var index = Math.round(scroller.scrollLeft / scroller.offsetWidth);
  var activeSlide = slides[index];
  if (!activeSlide) return;

  var dm = activeSlide.querySelector('deferred-media');
  if (!dm) return;

  var existingVideo = dm.querySelector('video');
  if (existingVideo) { existingVideo.muted = true; existingVideo.play(); return; }

  var pb = dm.querySelector('[ref="deferredMediaPlayButton"]');
  if (pb) pb.click();

  var mo = new MutationObserver(() => {
    var video = dm.querySelector('video');
    if (video) { video.muted = true; video.play(); mo.disconnect(); }
  });
  mo.observe(dm, { childList: true, subtree: true });
}

function triggerVideo(slideEl) {
  if (!slideEl) return;
  const dm = slideEl.querySelector('deferred-media');
  if (!dm) return;

  const existingVideo = dm.querySelector('video');
  if (existingVideo) {
    existingVideo.muted = true;
    existingVideo.play();
    return;
  }

  const pb = dm.querySelector('[ref="deferredMediaPlayButton"]');
  if (pb) pb.click();

  const mo = new MutationObserver(() => {
    const video = dm.querySelector('video');
    if (video) {
      video.muted = true;
      video.play();
      mo.disconnect();
    }
  });
  mo.observe(dm, { childList: true, subtree: true });
}

function pauseVideo(slideEl) {
  const video = slideEl.querySelector('video');
  if (video) { video.pause(); video.currentTime = 0; }
}

function initGridVideoAutoplay(galleryEl) {
  if (!galleryEl) return;
  const gridItems = Array.from(galleryEl.querySelectorAll('.media-gallery__grid .product-media-container'));
  if (!gridItems.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        triggerVideo(entry.target);
      } else {
        pauseVideo(entry.target);
      }
    });
  }, { root: null, threshold: 0.5 });

  gridItems.forEach((item) => {
    observer.observe(item);
  });
}

function attachScroller(scroller) {
  if (!scroller || scroller._videoListenerAttached) return;
  scroller._videoListenerAttached = true;

  let scrollTimer = null;
  scroller.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const slides = Array.from(scroller.querySelectorAll(':scope > *'));
      const index = Math.round(scroller.scrollLeft / scroller.offsetWidth);
      slides.forEach((s, i) => {
        if (i !== index) pauseVideo(s);
      });
      triggerVideo(slides[index]);
    }, 150);
  }, { passive: true });

  const slides = Array.from(scroller.querySelectorAll(':scope > *'));
  const initIndex = Math.round(scroller.scrollLeft / scroller.offsetWidth);
  triggerVideo(slides[initIndex]);
}

function findAndAttach() {
  // Runs on every mutation, so bail before the querySelectorAll/getComputedStyle work
  // on the templates that have no gallery at all.
  if (!document.querySelector('.original-gallery, .abtest-gallery')) return;

  document.querySelectorAll('.original-gallery slideshow-slides, .abtest-gallery slideshow-slides').forEach((scroller) => {
    const gallery = scroller.closest('.original-gallery, .abtest-gallery');
    if (gallery && getComputedStyle(gallery).display !== 'none') {
      attachScroller(scroller);
    }
  });

  document.querySelectorAll('.original-gallery, .abtest-gallery').forEach((gallery) => {
    if (getComputedStyle(gallery).display !== 'none') {
      if (!gallery._gridVideoAttached) {
        gallery._gridVideoAttached = true;
        initGridVideoAutoplay(gallery);
      }
    }
  });
}

// Coalesced to one run per frame: this watches class/style across the whole document,
// and findAndAttach() calls getComputedStyle(), which forces a style recalc. Safe
// because findAndAttach() is idempotent (guarded by flags on the element).
let bodyScanQueued = false;
const bodyObserver = new MutationObserver(() => {
  if (bodyScanQueued) return;
  bodyScanQueued = true;
  requestAnimationFrame(() => {
    bodyScanQueued = false;
    findAndAttach();
  });
});

function startBodyObserver() {
  const target = document.body || document.documentElement;
  if (!target) return;
  bodyObserver.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    findAndAttach();
    startBodyObserver();
  });
} else {
  findAndAttach();
  startBodyObserver();
}

// ─────────────────────────────────────────────
// DOMContentLoaded — LE gallery init on load
// ─────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product-information .fieldset-version') != null) {
    var getlimited = document.querySelector('.product-information .fieldset-version');
    if (getlimited) {
      var limitedInput = getlimited.querySelector('.variant__input--other-swatch[value="Limited Edition"], .variant__input--other-swatch[data-value="limited-edition"]');
      if (limitedInput) {
        limitedInput.checked = true;
        limitedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    setTimeout(() => {
      if (document.body.classList.contains('color-variant-wise-gallery')) return;

      var fieldsetVersion = document.querySelector('.product-details .fieldset-version');
      if (!fieldsetVersion) return;

      var hasLabelInfo = fieldsetVersion.querySelector('.variant-option__button-label');
      if (!hasLabelInfo) return;

      var checkedVersion = fieldsetVersion.querySelector('.variant__input--other-swatch:checked');
      var getVersion     = checkedVersion ? checkedVersion.value : '';

      limitedEditionGalleryChange(getVersion);
    }, 400);
  }
});

// ─────────────────────────────────────────────
// Gallery observer — color slide scroll
// ─────────────────────────────────────────────

(() => {

  var galleryObserver = new MutationObserver((mutations) => {
    var galleryReplaced = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (galleryReplaced) return;
        var isGallery  = node.matches && node.matches('.original-gallery, .abtest-gallery');
        var hasGallery = node.querySelector && node.querySelector('.original-gallery, .abtest-gallery');
        if (isGallery || hasGallery) galleryReplaced = true;
      });
    });

    if (!galleryReplaced) return;

    // Re-apply correct gallery visibility (Horizon wiped inline styles on re-render)
    limitedEditionGalleryChange(getCurrentVersion());

    findAndAttach();

    // Schedule scroll at 300ms — gives Horizon time to finish reinitializing the
    // gallery after the style.display change above, preventing a second scroll from
    // Horizon resetting scrollLeft back to 0 which previously triggered the safety net.
    // scheduleColorSlideScroll cancels syncColorUI's pending 300ms scroll so only
    // ONE scroll fires regardless of which path arrives first.
    scheduleColorSlideScroll(300);
  });

  function startGalleryObserver() {
    var target = document.body || document.documentElement;
    if (!target) return;
    galleryObserver.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGalleryObserver);
  } else {
    startGalleryObserver();
  }

})();
/**************************  PRODUCT BUNDLE SELECTOR -- END  ************************/

/************************** PDP PAGE FOR SHOP THE LOOKUP JS START ****************************/
function buildHandleForCard(cardEl) {
  var parts = [];

  // radio-type variants (color/version etc.)
  var fieldsets = qsa('.variant-wrapper .variant-input-wrap', cardEl);
  fieldsets.forEach((wrap) => {
    var checkedInput = wrap.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      parts.push(handleize(checkedInput.value));
    }
  });

  // dropdown-type variants (size etc.)
  var dropdowns = qsa('.variant-wrapper--dropdown select', cardEl);
  dropdowns.forEach((sel) => {
    if (sel.value) {
      parts.push(handleize(sel.options[sel.selectedIndex].textContent));
    }
  });

  var builtHandle = parts.join('-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
  return builtHandle;
}

function getMatchedOptionForCard(cardEl) {
  var builtHandle = buildHandleForCard(cardEl);
  var mainSelect = qs('.product-single__variants', cardEl);
  if (!mainSelect) return null;

  var matchedOption = null;
  Array.prototype.forEach.call(mainSelect.options, (opt) => {
    if (opt.getAttribute('data-handle') === builtHandle) {
      matchedOption = opt;
    }
  });

  return matchedOption;
}

function updatelookupBundlePrice() {
  var totalPrice = 0;
  var totalcomparePrice = 0;
  var checkedCards = qsa('.productlook');

  checkedCards.forEach((card) => {
    var checkbox = qs('.pc_header_checbox input', card);
    if (!checkbox || !checkbox.checked) return;
    var matchedOption = getMatchedOptionForCard(card);
    if (matchedOption) {
      var price = matchedOption.getAttribute('data-oprice');
      var compareprice = matchedOption.getAttribute('data-ocprice');
      totalPrice += parseFloat(price) || 0;
      totalcomparePrice += parseFloat(compareprice) || 0;
    }
  });
  var bundlePriceEl = qs('.mps-lookbook-products--section .pc_header_pricebox .sale_price');
  if (bundlePriceEl) {
    bundlePriceEl.textContent = Shopify.formatMoney(totalPrice);
  }
  var bundlecomparePriceEl = qs('.mps-lookbook-products--section .pc_header_pricebox .compare_price');
  if (bundlecomparePriceEl) {
    bundlecomparePriceEl.textContent = Shopify.formatMoney(totalcomparePrice);
  }
  if(document.querySelector('.mps-lookbook-products--section .product_lookcard .pc_header_checbox .atc_checkbox')!=null){
    document.querySelector('.mps-lookbook-products--section .product_lookcard .pc_header_checbox .atc_checkbox')?.setAttribute('data-price', totalPrice);
  }
}
function updateTotalPrice() {
  const lookbook = document.querySelector('.pdp-main-lookbook .custom-shopthelook');
  const checkboxes = lookbook.querySelectorAll('input.atc_checkbox:checked');
  let total = 0;

  checkboxes.forEach((cb) => {
    total += parseInt(cb.dataset.price) || 0;
  });

  const btn = document.querySelector('.talb-plist_btn');
  if (!btn) return;
  if (total > 0) {
    var formatted = Shopify.formatMoney(total, Shopify.currency.active_format);
    btn.textContent = 'Add to Cart — ' + formatted;
  } else {
    btn.textContent = 'Add to Cart';
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-shopthelook, .section-shoplook-list').forEach((section) => {
    if (window.getComputedStyle(section).display === 'none') {
      section.innerHTML = '';
    }
    //setTimeout(function(){
      updatelookupBundlePrice();
    //},2000);
  });
});
(() => {
  document.addEventListener('change', (e) => {
    var target = e.target;
    if (!target.matches('input[type="radio"][data-variant-input]')) return;

    var productCard = target.closest('.product_lookcard');
    if (!productCard) return;

    var label = productCard.querySelector('.color-variant .variant__label-info span');
    if (label && target.closest('.color-variant')) {
      label.innerText = target.value;
    }

    var variantId = target.getAttribute('data-vid');
    var mediaId = target.getAttribute('data-media-id');

    //console.log('media:', mediaId);

    lookbookGallerySync(productCard, mediaId);
    updatelookupBundlePrice();
    updateTotalPrice();
  });

  function lookbookGallerySync(productCard, mediaId) {
    var gallery = productCard.querySelector('.limited-gallery-slider');
    if (!gallery) {
      return;
    }

    var targetSlide = null;

    if (mediaId) {
      targetSlide = gallery.querySelector('.swiper-slide[data-media-id="' + mediaId + '"]');
    }

    if (!targetSlide) {
      return;
    }

    var slide = targetSlide.closest('.swiper-slide');
    var slides = Array.from(gallery.querySelectorAll('.swiper-slide'));
    var slideIndex = slides.indexOf(slide);


    if (gallery.swiper && slideIndex >= 0) {
      gallery.swiper.slideTo(slideIndex);
      gallery.swiper.update();
      return;
    }

    gallery.querySelectorAll('.swiper-slide a').forEach((a) => {
      a.style.display = 'none';
    });

    var targetA = slide.querySelector('a');
    if (targetA) targetA.style.display = '';
  }
})();

//MOBILE DEVICE ATC FOR SELECTED PRODUCTS START
document.addEventListener('DOMContentLoaded', () => {

  let lookbook = document.querySelector('.pdp-main-lookbook .custom-shopthelook');
  if(lookbook) {
    const style = window.getComputedStyle(lookbook);
    const isVisible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0';
    if(isVisible == false){
      lookbook = document.querySelector('.pdp-main-lookbook-list .section-shoplook-list');
      //console.log("lookbook other",lookbook);
      if(lookbook){
        const versionRadios = lookbook.querySelectorAll('.product-variants .variant-input-wrap-version input[type="radio"]');

        if (versionRadios.length > 1) {
          versionRadios[1].click();
        }

        var getVersion = lookbook.querySelector('.product-variants .variant-input-wrap-version input[type="radio"]:checked').value;
        if(getVersion){
          lookbook.querySelector('.product-variants .version-variant [data-variant-color-label]').innerText = getVersion;
        }

        const wrappers = lookbook.querySelectorAll('.product-variants .variant-input-wrap-color');
        if(wrappers){
          wrappers.forEach(wrapper => {
            const radio = wrapper.querySelector('input[type="radio"]');

            if (radio) {
              radio.click();
            }
          });
        }
      }
    }
  }
  if (!lookbook) return;
  //console.log("lookbook",lookbook);
  lookbook.addEventListener('change', (e) => {
    if (!e.target.classList.contains('atc_checkbox')) return;
    updateTotalPrice();
  });

  // Page load time call karo
  updateTotalPrice();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.talb-plist_btn');
    if (!btn) return;
    e.preventDefault();

    const productLooks = lookbook.querySelectorAll('.productlook');
    const originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart.js')
    .then(res => res.json())
    .then((cart) => {
      const existingIds = cart.items.map(item => item.variant_id);

      const items = [];
      productLooks.forEach((productLook) => {
        const checkbox = productLook.querySelector('input.atc_checkbox');
        if (!checkbox || !checkbox.checked) return;

        const variantInput = productLook.querySelector('input.variant-id-input');
        const id = parseInt(variantInput?.value);
        if (!id) return;

        if (existingIds.includes(id)) return;

        items.push({ id: id, quantity: 1 });
      });

      if (items.length === 0) {
        refreshCartDrawer(true);
        btn.disabled = false;
        btn.textContent = originalText;
        return Promise.resolve(null);
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(res => res.json());
    })
    .then((data) => {
      if (!data) return;
      btn.disabled = false;
      btn.textContent = originalText;
      const allProductLooks = lookbook.querySelectorAll('.productlook');
      const last2 = Array.from(allProductLooks).slice(-2);
      last2.forEach((productLook) => {
        const checkbox = productLook.querySelector('input.atc_checkbox');
        if (checkbox) checkbox.checked = false;
      });

      updateTotalPrice();
      refreshCartDrawer(true);
    })
    .catch((err) => {
      console.error('Cart add error:', err);
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });

});
//MOBILE DEVICE ATC FOR SELECTED PRODUCTS END

/************************** PDP PAGE FOR SHOP THE LOOKUP JS END ****************************/


/************************** GLOBAL SIZE SELECTOR JS START ****************************/
(function () {
  if (window.__ptGlobalSizeLoaded) return;
  window.__ptGlobalSizeLoaded = true;

  const STORAGE_KEY = 'pt_global_size';
  let isApplying = false;

  function normalize(str) {
    return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function extractSizeTokens(value) {
    const parts = value.split('/').map((p) => p.trim()).filter(Boolean);
    const tokens = [];

    parts.forEach((part) => {
      const plainMatch = part.match(/^(\d+)\s*mm$/i);
      if (plainMatch) {
        tokens.push(plainMatch[1] + 'MM');
        return;
      }
      const seriesMatch = part.match(/series\s*([\d]+(?:\s*&\s*[\d]+)?(?:-\d+)?)/i);
      const numMatch = part.match(/(\d+)\s*mm/i);
      if (seriesMatch && numMatch) {
        tokens.push(numMatch[1] + 'MM (Series ' + seriesMatch[1] + ')');
      }
    });

    return tokens;
  }

  function getAllSelectors() {
    return document.querySelectorAll('.global-size-selector__select');
  }

  function saveSize(value) {
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  function setSelectorValue(select, value) {
    const targetNorm = normalize(value);
    Array.from(select.options).forEach((option, index) => {
      const isMatch = normalize(option.value) === targetNorm;
      if (isMatch) {
        select.selectedIndex = index;
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    });
  }

  function syncAllSelectors(value) {
    getAllSelectors().forEach((select) => setSelectorValue(select, value));
  }

  function clickRadio(input) {
    const label = input.closest('label');
    if (label) {
      label.click();
    } else {
      input.click();
    }
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('click', { bubbles: true }));
  }

  function applySizeToPage(value) {
    if (!value) return;
    const targetNorm = normalize(value);

    document.querySelectorAll('fieldset.fieldset-size').forEach((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));

      const exactMatch = inputs.find((input) => normalize(input.value) === targetNorm);
      if (exactMatch) {
        if (!exactMatch.checked) clickRadio(exactMatch);
        return;
      }

      const groupedMatch = inputs.find((input) => {
        const tokens = extractSizeTokens(input.value);
        return tokens.some((t) => normalize(t) === targetNorm);
      });
      if (groupedMatch && !groupedMatch.checked) {
        clickRadio(groupedMatch);
      }
    });
  }

  function bindAllSelectors() {
    getAllSelectors().forEach((select) => {
      if (select.dataset.ptSizeBound) return;
      select.dataset.ptSizeBound = 'true';

      select.addEventListener('change', function (e) {
        const value = e.target.value;
        saveSize(value);
        isApplying = true;
        syncAllSelectors(value);
        applySizeToPage(value);
        setTimeout(() => { isApplying = false; }, 50);
      });
    });
  }

  function fullResync() {
    if (isApplying) return;
    const saved = localStorage.getItem(STORAGE_KEY);
    bindAllSelectors();
    if (saved) {
      isApplying = true;
      syncAllSelectors(saved);
      applySizeToPage(saved);
      setTimeout(() => { isApplying = false; }, 50);
    }
  }

  function init() {
    fullResync();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  setInterval(function () {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return;
    let needsFix = false;
    getAllSelectors().forEach((select) => {
      if (normalize(select.value) !== normalize(saved)) needsFix = true;
    });
    if (needsFix) fullResync();
  }, 400);

  let debounceTimer = null;
  const globalObserver = new MutationObserver(function () {
    if (isApplying) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fullResync, 30);
  });
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['selected', 'class']
  });

  console.log('[GlobalSize] Script loaded and running');
})();
/************************** GLOBAL SIZE SELECTOR JS END ****************************/